import DateFnsUtils from '@date-io/date-fns';
import AssignmentIcon from '@material-ui/icons/Assignment';
import SearchIcon from '@material-ui/icons/Search';
import ChatIcon from '@material-ui/icons/Chat';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import { moneyFormat } from 'src/utils/Common';
import FreeBreakfastIcon from '@material-ui/icons/FreeBreakfast';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import {
  Container,
  Avatar,
  TableRow,
  TableCell,
  Backdrop,
  Table,
  TableHead,
  TableBody,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Paper,
  TableContainer,
  Checkbox,
  CardActionArea,
  CardMedia,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  FormGroup,
  FormControl,
  CircularProgress,
  createMuiTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Link,
  List,
  ListItemSecondaryAction,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Snackbar,
  Switch,
  TextField,
  Typography,
  Menu
} from '@material-ui/core';
import 'date-fns';
import clsx from 'clsx';
import {
  getConsumerScreen,
  getConsumerAddressScreen,
  setConsumerScreen,
  setConsumerAddressScreen,
  getUser
} from 'src/utils/Common';
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Zoom from "@material-ui/core/Zoom";
import Fab from "@material-ui/core/Fab";
import UpIcon from "@material-ui/icons/KeyboardArrowUp";
import { green, red } from '@material-ui/core/colors';
import AddBoxIcon from '@material-ui/icons/AddBox';
import AttachmentIcon from '@material-ui/icons/Attachment';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import BusinessCenterRoundedIcon from '@material-ui/icons/BusinessCenterRounded';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import HomeIcon from '@material-ui/icons/Home';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import NextWeekIcon from '@material-ui/icons/NextWeek';
import NextWeekRoundedIcon from '@material-ui/icons/NextWeekRounded';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import SaveIcon from '@material-ui/icons/Save';
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import VideogameAssetIcon from '@material-ui/icons/VideogameAsset';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useCooldown } from 'src/hooks/useCooldown';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useHistory } from 'react-router';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import customAxios from 'src/utils/customAxios';
import validator from 'validator';
import DisplayField from '../../components/DisplayField';
import AppReasonSearch from '../../components/Selects/AppReasonSearch';
import DistributorSearch from 'src/components/Selects/DistributorSearch'
import ProductWorkCaseSearch from '../../components/Selects/ProductWorkCaseSearch';
import RetailerSearch from '../../components/Selects/RetailerSearch';
import ImageIcon from '@material-ui/icons/Image';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials
} from '../../store/actions';
import ReactFlagsSelect from 'react-flags-select';
import SmsIcon from '@material-ui/icons/Sms';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import InstagramIcon from '@material-ui/icons/Instagram';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { DataGrid } from '@material-ui/data-grid';
import SearchBar from 'material-ui-search-bar';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { sc } from 'src/utils/Common';
import Moment from 'moment';
import ExcelExport from 'src/components/TaskManagementExcelExport';
import OmniExcelReport from 'src/components/ExcelExport'
import { FcGoogle } from 'react-icons/fc';
import { MdPlace } from 'react-icons/md';
import AssertInsertDialog from 'src/views/Overview/AssetInsertDialog'
import AssertInsertDaysDialog from 'src/views/Overview/AssetInsertDaysDialog'
import rawCountries from 'src/views/Overview/rawCountries'
import { maskStringData, maskPhoneData } from 'src/MaskData'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import SendIcon from '@material-ui/icons/Send';
import CancelIcon from '@material-ui/icons/Cancel';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { getFilteredTasksRequest, setTask, setTasksFilterModel } from '../../store/actions/taskActions';
import { connect, useDispatch, useSelector } from 'react-redux';
import ForConsumer from '../MaterialOrder2/Create/ForConsumer';
import AddIcon from '@material-ui/icons/Add';
import { customerActions, customerThunks } from '../../store/slices/customerSlice'

const useStyles = makeStyles(theme => ({
  rootTopBar: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    paddingTop: 20,
    paddingLeft: 20,
    paddingBottom: 20,
    paddingRight: 20
  },
  fabGreen: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    color: theme.palette.common.white,
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[600]
    }
  },
  inputTopBar: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButtonTopBar: {
    padding: 10
  },
  dividerTopBar: {
    height: 28,
    margin: 4
  },
  cover: {
    height: '140'
  },
  avatarAtanan: {
    backgroundColor: red[500]
  },
  avatar1Atanan: {
    backgroundColor: green[500]
  },
  valueAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  typeAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  searchAtanan: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconAtanan: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInputAtanan: {
    flexGrow: 1
  },
  pageStyleAtanan: {
    display: 'flex',
    padding: '2px 4px'
  },
  inputAtanan: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButtonAtanan: {
    padding: 10
  },
  fieldsAtanan: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  actions: {
    justifyContent: 'flex-end'
  },

  cardscontent: {
    minHeight: 500,
    minWidth: 400
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  cardsInfoMax: {
    // maxHeight: 230,
    minHeight: 200
  },
  cardsMax: {
    maxHeight: 230,
    minHeight: 230
  },
  cardsMaxM: {
    maxHeight: 230,
    minHeight: 230,
    position: 'relative',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    }
  },
  cardsAssetMax: {
    maxHeight: 550,
    minHeight: 550
  },
  cardsContentMax: {
    maxHeight: 180,
    minHeight: 180
  },
  cardsMaxF: {
    // maxHeight: 230,
    minHeight: 350
  },
  cardsContentMax: {
    maxHeight: 180,
    minHeight: 150
  },
  cardsContentMaxF: {
    // maxHeight: 180,
    minHeight: 300
  },

  cardscontent: {
    minHeight: 350
  },
  cards: {
    minHeight: 630
    // maxHeight: 500,
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  cardArddress: {
    minHeight: 340,
    maxHeight: 340
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: '#A9B388',
    transition: 'background-color 0.3s, box-shadow 0.3s',
    '&:hover': {
      backgroundColor: '#5F6F52',
      boxShadow: theme.shadows[16],
      transform: 'scale(1.1)'
    },
    display: 'none',
  },
  fabVisible: {
    display: 'block',
  }
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});
const localeMap = {
  tr: trLocale
};

const DefaultConsumerValue = {
  SearchId: 0,
  Search: '',
  LanguageCode: '',
  EmployeeId: '',
  Phones: [],
  Addresses: [
    {
      AddressType: '',
      Address: '',
      State: '',
      AddressItem: '',
      Apartment: '',
      City: '',
      Country: '',
      District: '',
      DoorNr: '',
      Latitude: 0,
      Longitude: 0,
      Neighborhood: '',
      PostCode: '',
      Region: '',
      Street: '',
      PrimaryAddress: true,
      AddressTypeId: 1,
      AddressId: 0
    }
  ],
  Title: '',
  FirstName: '',
  MiddleName: '',
  LastName: '',
  Email: '',
  Active: true,
  ConsumerId: 0,
  CustomerTypeId: 0,
  InsurancePlanNumber: '',
  ReferralNumber: '',
  WorkCaseCount: 0,
  AssetCount: 0,
  FeedBackCount: 0,
  CreateEmployee: "",
  UpdateEmployee: "",
  UpdateDate: "",
  CreateDate: "",
  VIP: false,
};

const DefaultWorkCase = {
  ConsumerId: 0,
  ProductId: 0,
  ProductionYear: 0,
  ProductionMonth: 0,
  SerialNr: '',
  Product: '',
  SKU: '',
  OnSiteOperation: 0,
  WarrantyTypeId: 0,
  IssueId: 1,
  Issue: '',
  RetailerId: 0,
  Retailer: '',
  DistributorId: 1,
  Distributor: '',
  StatusId: 1,
  Comment: '',
  WarrantyDate: null,
  PotentialLiabiltiy: 0,
  AppointmentDate: moment()
    .startOf('day')
    .add(1, 'days')
    .add(12, 'hours')
    .format('YYYY-MM-DD hh:mm'),
  AppointmentEndDate: moment()
    .startOf('day')
    .add(1, 'days')
    .add(13, 'hours')
    .format('YYYY-MM-DD hh:mm')
};

const DefaultGdprValue = {
  ConsumerId: 0,
  Sms: false,
  Email: false,
  Phone: false,
  Whatsapp: false,
  SocialMedia: false,
  Message: false,
  EmployeeId: 0
};

function AssignedJob({
  className,
  AtananIsler,
  handleRefresh,
  loading,
  setTask,
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials,
  readonly,
  tasks,
  ReceiptNo,
  row
}) {

  const SessionUser = getUser();
  if (SessionUser.ServiceShopTypeId == 15 && SessionUser.IsIhpTenant) {
    return null;
  }

  const classes = useStyles();
  const { t } = useTranslation('overview');
  const [Required, setRequired] = React.useState(false);
  const [consumerMaterialOrders, setConsumerMaterialOrders] = useState([]);
  const [openMaterialOrdersPopUp, setOpenMaterialOrdersPopUp] = useState(false);
  const [RequiredAddress, setRequiredAddress] = useState(false);
  const [selectedValues, setSelectedValues] = React.useState([]);
  const [RequiredWorkCase, setRequiredWorkCase] = useState(false);
  const [GoogleAddressSearchResult, setGoogleAddressSearchResult] = useState(
    []
  );
  const [
    requiredForInternalNotes,
    setRequiredForInternalNotes
  ] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const locale = localStorage.getItem('i18nextLng');
  const [IssueTypeId, setIssueTypeId] = React.useState(1);
  const [addressGoogleSearch, setaddressGoogleSearch] = React.useState('');
  const [TaskOpenCase, setTaskOpenCase] = React.useState(false);
  const [TaskOpenDay, setTaskOpenDay] = React.useState(0);
  const [CountryDataControl, setCountryDataControl] = React.useState({});
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [OpenMaterialOrder, setOpenMaterialOrder] = useState(false);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });

  const [anchorElScreen, setAnchorElScreen] = React.useState(null);
  const [anchorElAddressScreen, setAnchorElAddressScreen] = React.useState(
    null
  );
  var phoneRef;
  const openScreen = Boolean(anchorElScreen);
  const openAddressScreen = Boolean(anchorElAddressScreen);

  const [state, setState] = React.useState({
    IdNrScreen: true,
    TaxOfficeScreen: true,
    TaxIdScreen: true,
    ExceptIdScreen: true,
    InsurancePlanNumberScreen: true,
    ReferralNumberScreen: true
  });

  const [stateAddress, setStateAddress] = React.useState({
    StateScreen: true,
    RegionScreen: true,
    ApartmentScreen: true,
    DoorNrScreen: true,
    PostCodeScreen: true,
    LongitudeScreen: true,
    LatitudeScreen: true
  });

  const [stateMobile, setStateMobile] = React.useState({
    top: false
  });
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setStateMobile({ ...stateMobile, [anchor]: open });
  };

  const handleChangeScreen = event => {
    var Control = { ...state };
    setState({ ...state, [event.target.name]: event.target.checked });
    var Control1 = { ...Control, [event.target.name]: event.target.checked };
    setConsumerScreen(Control1);
  };

  const handleChangeAddressScreen = event => {
    var Control = { ...stateAddress };
    setStateAddress({
      ...stateAddress,
      [event.target.name]: event.target.checked
    });
    var Control1 = { ...Control, [event.target.name]: event.target.checked };
    setConsumerAddressScreen(Control1);
  };


  const tasksFilterModel = useSelector((state) => state.tasksNewReducer.filterModel);
  const TasksData = useSelector((state) => state.tasksNewReducer.response?.tasksScreenResult);
  const TasksScreenData = useSelector((state) => state.tasksNewReducer.response?.tasksScreenResult);
  const detailedExcelData = useSelector((state) => state.tasksNewReducer.response?.excelDetailedDatas)
  const isGetTaskRequestSending = useSelector((state) => state.tasksNewReducer.isRequestSending)
  const requestFailed = useSelector((state) => state.tasksNewReducer.requestFailed)
  const { isOnCooldown: isTaskCooldownActive, remainingSeconds: taskRemainingSeconds, triggerCooldown: triggerTaskCooldown, triggerCooldownByDateRange: triggerTaskCooldownByDateRange, resetCooldown: resetTaskCooldown } = useCooldown('GetTasksDataDetail')


  const dispatch = useDispatch();

  const {
    IdNrScreen,
    TaxOfficeScreen,
    TaxIdScreen,
    ExceptIdScreen,
    InsurancePlanNumberScreen,
    ReferralNumberScreen
  } = state;

  const {
    StateScreen,
    RegionScreen,
    ApartmentScreen,
    DoorNrScreen,
    PostCodeScreen,
    LongitudeScreen,
    LatitudeScreen
  } = stateAddress;

  const [jobSearchPopup, setJobSearchPopup] = useState(false);
  const [LoadingControl, setLoadingControl] = useState(false);
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [ConfirmTitle, setConfirmTitle] = useState('');
  const [ConfirmDescription, setConfirmDescription] = useState('');
  const [loading2, setLoading2] = useState(false);
  const [StartDateSearch, setStartDateSearch] = useState(pastWeek());
  const [EndDateSearch, setEndDateSearch] = useState(new Date());
  const [scroll, setScroll] = React.useState('paper');
  const [secretNotePopUp, SetSecretNotePopUp] = useState(false);
  Moment.locale(SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode);
  moment.locale(SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode);

  var today = new Date();
  const [StartDate, setStartDate] = useState(new Date(today));
  const [EndDate, setEndDate] = useState(new Date(today));
  const [SearchList, setSearchList] = useState({});
  const [openChooseDate, setopenChooseDate] = useState(false);
  const history = useHistory();
  //const [SearchType, setSearchType] = useState(1);
  const [TopBarValue, setTopBarValue] = React.useState(-1);
  const [SecretNoteData, setSecretNoteData] = useState([]);
  const [isButtonDisabled, setisButtonDisabled] = React.useState(false);
  const [emailError, setEmailError] = useState('');
  const [ValidControlColor, setValidControlColor] = useState(false);
  const [RequiredWorkCaseComment, setRequiredWorkCaseComment] = useState(false);
  const [newtel, setNewTel] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [PhoneTypes, setPhoneTypes] = useState([]);
  const [AddressTypes, setAddressTypes] = useState([]);
  const [consumerTitleData, setConsumerTitleData] = useState([]);
  const [VulnerabilitiesData, setVulnerabilitiesData] = useState([]);
  const [VulnerabilitiesId, setVulnerabilitiesId] = useState(0);
  const [PlaceData, setPlaceData] = useState([]);
  const [WarrantyData, setWarrantyData] = useState([]);
  const [AddressIndex, setAddressIndex] = useState(0);
  const [ParamPhonesType, setParamPhonesType] = useState(PhoneTypes[0]);
  const [formData, setFormdata] = useState(DefaultConsumerValue);
  const [AddressPopup, setAddressPopup] = useState(false);
  const [SecretNote, setSecretNote] = useState('');
  const [AddressCount, setAddressCount] = useState(0);
  const [WorkCasePopup, setWorkCasePopup] = useState(false);
  const [Assets, setAssets] = useState([]);
  const [AssetPopup, setAssetPopup] = useState(false);
  const [CustomerTypeData, setCustomerTypeData] = useState([]);
  const [RegionData, setRegionData] = useState([]);
  const [CityData, setCityData] = useState([]);
  const [DistrictData, setDistrictData] = useState([]);
  const [NeighborhoodData, setNeighborhoodData] = useState([]);
  const [PostCodeData, setPostCodeData] = useState([]);
  const [searched, setSearched] = useState('');
  const [Rows, setRows] = useState('');
  const [initialRows, setinitialRows] = useState('');
  const [StatusData, setStatusData] = useState([]);
  const [ServiceShopData, SetServiceShopData] = useState([]);
  const [serviceShopId, setServiceShopId] = useState(SessionUser.ServiceShopId);
  const [openFeedbackPopup, setOpenFeedbackPopup] = useState(false);
  const [openFeedbackDetailPopUp, setOpenFeedbackDetailPopup] = useState(false);
  const [feedback, setFeedback] = useState([]);
  const [insertAssetPopup, setInsertAssetPopup] = useState(false)
  const [insertAssetDaysPopup, setInsertAssetDaysPopup] = useState(false)
  // const [Districtfiltered, setDistrictFiltered] = useState(false);
  // const [PostCodefiltered, setPostCodeFiltered] = useState(false);


  const DefaultAdressSearchValue = {
    TenantId: SessionUser.TenantId,
    Region: '',
    City: '',
    District: '',
    PostCode: '',
    Neighborhood: ''
  };

  const [addressSearch, setAddressSearch] = useState(DefaultAdressSearchValue);
  const [addressSearchResult, setAddressSearchResult] = useState([]);
  const [StatusSeacrh, setStatusSeacrh] = useState(0);

  const [consumerActivePassive, setconsumerActivePassive] = useState(
    t('lblActive')
  );
  const [
    consumerAddressPrimarySecondary,
    setconsumerAddressPrimarySecondary
  ] = useState(t('lblPrimary'));

  const columns = [
    { field: 'lblWorkCaseId', headerName: t('lblWorkCaseID'), width: 120 },
    { field: 'lblWorkOrderId', headerName: t('lblWorkOrderID'), width: 120 },
    { field: 'lblServiceCode', headerName: t('lblServiceShopCode'), width: 150 },
    { field: 'lblServiceShop', headerName: t('lblServiceShop'), width: 200 },
    { field: 'lblWarrantyDate', headerName: t('lblWarrantyDate'), width: 200 },
    { field: 'lblOpenDays', headerName: t('lblOpenDays'), width: 200 },
    { field: 'lblWarrantyType', headerName: t('lblWarrantyType'), width: 200 },
    { field: 'lblStatus', headerName: t('lblStatus'), width: 200 },
    { field: 'lblAppointmentDate', headerName: t('lblAppointmentDate'), width: 200 },
    { field: 'lblStatusNote', headerName: t('lblStatusNote'), width: 200 },
    { field: 'lblCallCenterNote', headerName: t('lblCallCenterNote'), width: 200 },
    {
      field: 'lblRejectDescription',
      headerName: t('lblRejectDescription'),
      width: 200
    },
    {
      field: 'lblSpecialNote',
      headerName: t('lblSpecialNote'),
      width: 200
    },
    {
      field: 'lblFinalNote',
      headerName: t('lblFinalNote'),
      width: 200
    },
    { field: 'lblCustomer', headerName: t('lblConsumer'), width: 150 },
    {
      field: 'CustomerCity',
      headerName: t('lblCustomerCity'),
      width: 150
    },
    { field: 'lblUrgentCustomer', headerName: t('lblUrgentCustomer'), width: 150 },
    { field: 'lblBrand', headerName: t('lblBrand'), width: 150 },
    { field: 'lblProductGroup', headerName: t('lblProductGroup'), width: 150 },
    { field: 'lblSerialNumber', headerName: t('lblSerialNumber'), width: 150 },
    { field: 'lblProductCode', headerName: t('lblProductCode'), width: 150 },
    { field: 'lblProduct', headerName: t('lblProduct'), width: 250 },
    { field: 'lblCallDate', headerName: t('lblCallDate'), width: 150 },
    { field: 'lblRepairDate', headerName: t('lblRepairDate'), width: 150 },
    { field: 'lblTechnician', headerName: t('lblTechnician'), width: 150 },
    // { field: 'lblNPSScore', headerName: t('lblNPSScore'), width: 150 },
    { field: 'lblRetailer', headerName: t('lblRetailer'), width: 150 },
    { field: 'lblApplicationType', headerName: t('lblApplicationType'), width: 150 },
    { field: 'lblMaterialOrderList', headerName: t('lblMaterialOrderList'), width: 200 },
    { field: 'lblLabourPrice', headerName: t('lblLabourPrice'), width: 150 },
    { field: 'lblMaterialPrice', headerName: t('lblMaterialPrice'), width: 150 },
    { field: 'lblTransportPrice', headerName: t('lblTransportPrice'), width: 150 },
    { field: 'lblExtraPrice', headerName: t('lblExtraPrice'), width: 150 },
    { field: 'lblTotalPrice', headerName: t('lblTotalPrice'), width: 150 },
    { field: 'lblCreateUser', headerName: t('lblCreateUser'), width: 150 },
    { field: 'lblUpdateUser', headerName: t('lblUpdateUser'), width: 150 },
    { field: 'lblLastWorkOrder', headerName: t('lblLastWorkOrder'), width: 150 },
    { field: 'lblPostalCode', headerName: t('lblPostalCode'), width: 150 },
    { field: 'lblPlaceOfOperation', headerName: t('lblPlaceOfOperation'), width: 150 }
  ];

  const addressSearchResultColumns = [
    { field: 'Id', headerName: 'Id', width: 120 },
    { field: 'Region', headerName: t('lblRegion'), width: 120 },
    { field: 'City', headerName: t('lblCity'), width: 200 },
    { field: 'District', headerName: t('lblDistrict'), width: 200 },
    { field: 'PostCode', headerName: t('lblPostCode'), width: 120 },
    { field: 'Neighborhood', headerName: t('lblNeighborhood'), width: 120 }
  ];

  const [WorkCaseData, setWorkCaseData] = useState([]);
  const [NewWorkCaseData, setNewWorkCaseData] = useState(DefaultWorkCase);
  const [GdprData, setGdprData] = useState(DefaultGdprValue);
  const [VIP, setVIP] = useState(false);
  // const [InformationData, setInformationData] = useState([]); //NPS Kaldırıldı Data
  const [filteredIsler, setFilteredIsler] = useState(AtananIsler);
  const [NewWorkCasePopup, setNewWorkCasePopup] = useState(false);
  const [WorkOrderPopup, setWorkOrderPopup] = useState(false);
  const [ConsumerFilePopup, setConsumerFilePopup] = useState(false);
  const [GdprPopup, setGdprPopup] = useState(false);
  const [AnonymyzePopup, setAnonymyzePopup] = useState(false);
  // const [InformationPopup, setInformationPopup] = useState(false); //NPS Kaldırıldı Popup
  const [InformationDetailPopup, setInformationDetailPopup] = useState(false);
  const [workOrderId, setWorkOrderId] = useState();
  const [infoServiceShopId, setInfoServiceShopId] = useState();
  const [WorkOrderData, setWorkOrderData] = useState([]);
  const [Files, setFiles] = useState([]);
  const [selectedWarrantyType, setSelectedWarrantyType] = useState([]);
  const [newAssetChosen, setNewAssetChosen] = useState(false);
  const [assetChosen, setAssetChosen] = useState(false);
  const [warrantyDateDisable, setWarrantyDateDisable] = useState(false);
  const [DisabledControl, setDisabledControl] = useState(false);
  const [CountryData, setCountryData] = useState([]);
  const search = '';
  const SearchStr = sessionStorage.getItem('SearhResult');
  const [selected, setSelected] = useState(
    SessionUser.TenantCode.toUpperCase()
  );
  const [addressSearchPopup, setAddressSearchPopup] = useState(false);
  const [GoogleAddressSearchPopup, setGoogleAddressSearchPopup] = useState(
    false
  );

  const [feedbackDataList, setFeedbackDataList] = useState([]);

  const [feedbackList, setFeedbackList] = useState([]);
  const [savedWorkOrderId, setSaveWorkOrderId] = useState(0);
  const [searchData, setSearchData] = useState()
  const openWorkCasePopup = sessionStorage.getItem('openCases');
  const [fabVisible, setFabVisible] = useState(false);
  const [ResponseDsc, setResponseDsc] = useState('');
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseType, setResponseType] = useState('success');
  const [workCaseNumber, setWorkCaseNumber] = useState(0);
  const retailerControlTenantId = [68];
  const [modelCode, setModelCode] = useState('');

  const GetServiceShops = () => {
    const role = Number(SessionUser.Role);

    const request =
      Number(SessionUser?.TenantId) === 75 && SessionUser?.IsRegionZoneService
        ? axios.get('/GetRegionZoneServiceShops')
        : role === 1 || role === 2
          ? customAxios.get('/GetAuthorizedServiceShops')
          : axios.get('/GetServiceShopRequest/');

    request
      .then(response => {
        const serviceShops = response.data || [];

        SetServiceShopData(serviceShops);

        const hasAdditionalServiceAccess = serviceShops.length > 1;

        setDisabledControl(
          (role === 1 || role === 2) && !hasAdditionalServiceAccess
        );
      })
      .catch(() => {
        SetServiceShopData([]);
        setDisabledControl(role === 1 || role === 2);
      });
  };
  

  useEffect(() => {
    if (requestFailed) {
      resetTaskCooldown();
    }
  }, [requestFailed]);

  useEffect(() => {
    setLoading2(true);
    GetDistrictData("0", "0");
    GetPostCode('0', '0', '0');
    setLoading2(false);
  }, []);

  

  useEffect(() => {
    if (ServiceShopData.length === 0) {
      return;
    }

    const ownServiceShop = ServiceShopData.find(
      x => Number(x.ServiceShopId) === Number(SessionUser.ServiceShopId)
    );

    const selectedServiceShop =
      ownServiceShop || ServiceShopData[0];

    handleTasksInputChange({
      target: {
        name: 'serviceShopId',
        value: selectedServiceShop.ServiceShopId
      }
    });
  }, [ServiceShopData]);

  // useEffect(() => {
  //   setLoading2(true);
  //   if(openWorkCasePopup == 'true'){
  //     handleConsumerWorkCase();
  //     setLoading2(false);
  //   }
  //   else{
  //     setNewWorkCasePopup(true);
  //     setLoading2(false);
  //   }
  // },[formData.ConsumerId])

  const StartDatehandleChange = value => {
    var Deger = moment(value).format('YYYY-MM-DD');
    setStartDate(Deger);
    sessionStorage.removeItem('StartDate');
    sessionStorage.setItem('StartDate', Deger);
  };

  const handleUpdateDateChange = (e) => {
    const DateValue = moment(e).format('YYYY.MM.DD');
    setFormdata({ ...formData, UpdateDate: e });
  }


  const handleCreateDateChange = (e) => {
    const DateValue = moment(e).format('YYYY.MM.DD');
    setFormdata({ ...formData, CreateDate: DateValue });
  }

  const SetWarrantyDate = value => {
    var DateValue = moment(value).format('YYYY-MM-DD');

    setNewWorkCaseData({ ...NewWorkCaseData, WarrantyDate: DateValue });
  };

  const handleClickScreen = event => {
    setAnchorElScreen(event.currentTarget);
  };

  const handleClickAddressScreen = event => {
    setAnchorElAddressScreen(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElScreen(null);
  };
  const handleAddressClose = () => {
    setAnchorElAddressScreen(null);
  };

  const setAppointmentData = value => {
    var DateValue = moment(value).format('YYYY-MM-DD HH:mm');
    var PresentDate = moment(new Date()).format('YYYY-MM-DD HH:mm');
    var EndDateValue = moment(value)
      .add(1, 'hours')
      .format('YYYY-MM-DD HH:mm');
    if (DateValue < PresentDate) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Please make sure you select the appointment date correctly!')
      });
      setUyariTip('error');
      setUyari(true);
      setRequired(true);
      return;
    } else {
      setNewWorkCaseData({
        ...NewWorkCaseData,
        AppointmentDate: DateValue,
        AppointmentEndDate: EndDateValue
      });
    }
  };

  const EndDatehandleChange = value => {
    var Deger = moment(value).format('YYYY-MM-DD');
    setEndDate(Deger);
    sessionStorage.removeItem('EndDate');
    sessionStorage.setItem('EndDate', Deger);
  };

  const handleRefreshDate = e => {
    setopenChooseDate(false);
    handleRefresh();
  };

  // const GetCityRequestByDistrict  = districtName =>  {
  //     setLoading2(true);
  //     axios
  //       .get('/GetCityRequestByDistrict/'+districtName)
  //       .then(response => {
  //         setCityData(response.data);

  //         setLoading2(false);
  //       })
  //       .catch(error => {
  //         setLoading2(false);
  //       });
  //   };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const hataVer = ConsumerId => {
    setSearchData([]);
    setLoading2(true);
    axios
      .get('/GetConsumerById/' + ConsumerId)
      .then(res => {
        const response = res.data;
        setSearchData(response);
        setLocalSearhResult("", response[0]);
        setLoading2(false);
      })
      .catch(err => {
        setSearchData([]);
        setLoading2(false);
      });
  };



  const setLocalSearhResult = (event, ResponseData) => {
    sessionStorage.removeItem('SearhResult');
    sessionStorage.setItem('SearhResult', JSON.stringify(ResponseData));
    sessionStorage.removeItem('ConsumerId');
    sessionStorage.setItem('ConsumerId', ResponseData.ConsumerId);

    history.push('/overview');
    // if(ResponseData.OpenCases > 0){
    //   handleConsumerWorkCaseX(ResponseData.ConsumerId)
    // }
    // else {
    //   setNewWorkCasePopup(true);
    // }
    // handleClose();
  };

  function handleOnAdd() {
    if (SessionUser.TenantId === 68) {
      const phoneNumber = newtel.slice(countryCode.length);
      if (phoneNumber.length !== 10) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('The phone number must be 10 digits long.')
        });
        setUyariTip('error');
        setUyari(true);
        setRequired(true);
        return;
      }
    }
    axios
      .get('/CheckPhoneNumber/' + newtel)
      .then(response => {
        let ResponseData = response.data;
        // If the user select CustomerType 'Return' as customerType (9 or 10)
        // There will be a an exception in which 
        // we wont check if the user have already that phone number
        if (formData.CustomerTypeId == 9 || formData.CustomerTypeId == 10) {
          ResponseData = ""
        }
        if (ResponseData.length !== 0) {

          confirmAlert({
            message: ' Id: ' + ResponseData[0].ConsumerId + ' ' +
              ResponseData[0].Title + ' ' +
              ResponseData[0].FirstName + ' ' +
              ResponseData[0].MiddleName + ' ' +
              ResponseData[0].LastName + ' İlgili Consumera gitmek ister misiniz ?',
            buttons: [
              {
                label: t('Evet'),
                onClick: () => hataVer(ResponseData[0].ConsumerId)
              },
              {
                label: t('Hayir'),
                onClick: () => {
                  return;
                }
              }
            ]
          });
        }
        else {
          if (
            newtel === '' ||
            newtel === undefined ||
            ParamPhonesType === 0 ||
            ParamPhonesType === undefined ||
            ParamPhonesType === ''
          ) {
            setresponseMessage({
              ErrorCode: 10,
              ErrorDescription: t('lblMustFieldControl')
            });
            setUyariTip('error');
            setUyari(true);
            setRequired(true);
            return;
          }
          var PhonesData = [];
          if (formData.Phones?.length > 0)
            PhonesData = [...formData.Phones];

          var PhoneType = PhoneTypes.filter(item => item.Id === ParamPhonesType);
          var Data = {
            PhoneId: 0,
            Phone: newtel,
            PhoneTypeId: ParamPhonesType,
            PhoneType: PhoneType[0].Dsc
          };
          PhonesData.push(Data);
          setFormdata({ ...formData, Phones: PhonesData });
          setNewTel(countryCode);
        }
      })
      .catch(error => {
      });
  }

  const handleClickMap = (event, Latitude, Longitude) => {
    window.open(process.env.REACT_APP_MAP_URL + Latitude + ',' + Longitude);
    event.persist();
  };

  const GetSecretNote = SearchId => {
    setLoading2(true);
    axios
      .get('/GetConsumerSecretNote/' + SearchId)
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setSecretNoteData([]);
        } else {
          setSecretNoteData(ResponseData);
        }
        setLoading2(false);
      })
      .catch(error => {
        setSecretNoteData([]);
        setLoading2(false);
      });
  };

  const validateEmail = event => {
    var email = event.target.value;
    if (validator.isEmail(email) || email === '') {
      setEmailError('');
      setValidControlColor(false);
    } else {
      setEmailError('Enter valid Email!');
      setValidControlColor(true);
    }
    setFormdata({ ...formData, Email: event.target.value });
  };

  function pastWeek() {
    var today = new Date();
    var pastWeek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 7
    );
    return pastWeek;
  }

  function handleOnChange(value, country) {
    setNewTel(value);
    setCountryCode(country.dialCode);
    SetCountry(country.countryCode.toUpperCase(), AddressIndex);
    // changeRegionAndCityData(country.countryCode.toUpperCase());
  }

  function handleOnAddressAdd() {
    if (formData.ConsumerId === 0) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      setRequired(true);
      return;
    }

    const selected = formData.Addresses;
    var filteredIndex = selected.findIndex(x => x.AddressId === 0);

    if (filteredIndex > -1) {
      selected.splice(filteredIndex, 1);
      setFormdata({ ...formData, Addresses: selected });
    }

    var PrimaryControl = true;

    var ControlAddress = formData.Addresses.filter(
      x => x.PrimaryAddress === true
    );

    if (ControlAddress.length > 0) {
      PrimaryControl = false;
    }

    var AddressesData = [...formData.Addresses];
    var Data = {
      AddressType: '',
      Address: '',
      State: '',
      AddressItem: '',
      Apartment: '',
      City: '',
      Country: SessionUser.TenantCode.toUpperCase(),
      District: '',
      DoorNr: '',
      Latitude: 0,
      Longitude: 0,
      Neighborhood: '',
      PostCode: '',
      Region: '',
      Street: '',
      PrimaryAddress: PrimaryControl,
      AddressTypeId: 1,
      AddressId: 0
    };
    AddressesData.push(Data);

    setFormdata({ ...formData, Addresses: AddressesData });
    setAddressIndex(AddressesData.length - 1);
  }

  const GetPhoneTypes = () => {
    var phoneData = sessionStorage.getItem('phoneTypeData');
    if (phoneData !== undefined && phoneData !== null && JSON.parse(phoneData)[1].LanguageCode == localStorage.getItem('i18nextLng')) {
      setPhoneTypes(JSON.parse(phoneData));
      setParamPhonesType(JSON.parse(phoneData)[1].Id);
    }
    else {
      axios
        .get(`/GetPhoneTypes`)
        .then(response => {
          if (response.data.length > 0) {
            setPhoneTypes(response.data);
            setParamPhonesType(response.data[1].Id);
            var jsonData = JSON.stringify(response.data);
            sessionStorage.setItem('phoneTypeData', jsonData);
          }
        })
        .catch(error => { });
    }
  };
  const GetCustomerType = () => {
    axios
      .get(`/GetCustomerType`)
      .then(response => {
        if (response.data.length > 0) {
          setCustomerTypeData(response.data);
        }
      })
      .catch(error => { });
  };
  const GetPlace = () => {
    axios
      .get(`/GetPlace`)
      .then(response => {
        if (response.data.length > 0) {
          setPlaceData(response.data);
        }
      })
      .catch(error => { });
  };
  const GetWarranty = () => {
    axios
      .get(`/GetSiriusWarrantyType`)
      .then(response => {
        if (response.data.length > 0) {
          setWarrantyData(response.data);
        }
      })
      .catch(error => { });
  };
  const GetAddressTypes = () => {
    axios
      .get(`/GetAddressTypes`)
      .then(response => {
        if (response.data.length > 0) {
          setAddressTypes(response.data);
        }
      })
      .catch(error => { });
  };
  const GetVulnerabilitiesData = () => {
    axios
      .get(`/GetVulnerabilities`)
      .then(response => {
        if (response.data.length > 0) {
          setVulnerabilitiesData(response.data);
        }
      })
      .catch(error => { });
  };
  const GetConsumerTitlesData = () => {
    axios
      .get(`/GetConsumerTitles`)
      .then(response => {
        if (response.data.length > 0) {
          setConsumerTitleData(response.data);
        }
      })
      .catch(error => { });
  };
  const GetCountryData = () => {
    axios
      .get(`/GetCountryList`)
      .then(response => {
        if (response.data.length > 0) {
          setCountryData(response.data);
        }
      })
      .catch(error => { });
  };
  function handleOnCheck(event) {
    if (event.target.checked) {
      setconsumerActivePassive(t('lblActive'));
    } else {
      setconsumerActivePassive(t('lblPassive'));
    }
    setFormdata({ ...formData, Active: event.target.checked });
  }

  const handleTasksInputChange = e => {
    const { name, value } = e.target;

    dispatch(setTasksFilterModel({ name, value }));
  }


  function handleChangeAddressId(event, index) {
    var Value;
    if (event.target.type === 'checkbox') {
      Value = event.target.checked;
    } else {
      Value = event.target.value;
    }

    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[index], AddressTypeId: Value };
    Data[index] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
  }

  function handleChangeCountry(event, index) {
    var Value;
    if (event.target.type === 'checkbox') {
      Value = event.target.checked;
    } else {
      Value = event.target.innerText;
    }
    if (Value != null || Value != undefined)
      Value = CountryData.find(q => q.CountryName === Value);

    var Data = [...formData.Addresses];
    var CountryItem = { ...Data[index], Country: Value };
    Data[index] = CountryItem;
    setFormdata({ ...formData, Addresses: Data });
  }

  function handleChangeAddress(event, index) {
    var Value;
    if (event.target.type === 'checkbox') {
      Value = event.target.checked;
    } else {
      Value = event.target.value;
    }
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[index], [event.target.id]: Value };
    Data[index] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
  }

  function handleChangeAddressSearch(event) {
    var Value;
    if (event.target.type === 'checkbox') {
      Value = event.target.checked;
    } else {
      Value = event.target.value;
    }

    setAddressSearch({ ...addressSearch, [event.target.id]: Value });
  }

  useEffect(() => {
    setFormdata(formData);
    // handleConsumerWorkCase(0);
  }, [formData]);

  const ControlSearch = sessionStorage.getItem('AddNewCustomer');

  var phoneTypeData = [];

  if (PhoneTypes.length === 0) {
    var storagePhoneData = sessionStorage.getItem('phoneTypeData');
    if (storagePhoneData) {
      phoneTypeData = JSON.parse(storagePhoneData);
      GetPhoneTypes();
    }
  }

  var isNewCustomer = false;
  useEffect(() => {
    if (ControlSearch !== undefined && ControlSearch !== null &&
      (PhoneTypes.length > 0 || phoneTypeData.length > 0)) {
      isNewCustomer = true;
      GetSecretNote(0);

      // rawCountries PhoneInput componenti içindeki rawCountries.js'in bu projenin içine kopyalamasından alınıyor
      var countryDialCode = rawCountries
      countryDialCode = countryDialCode.filter(x => x[2] == SessionUser.TenantCode)[0]

      setFormdata({
        ...DefaultConsumerValue,
        Phones: [
          {
            PhoneTypeId: PhoneTypes[0].Id,
            PhoneType: PhoneTypes[0].Dsc,
            PhoneId: 0,
            Phone: CountryDataControl?.dialCode ? CountryDataControl?.dialCode + ControlSearch : countryDialCode[3] + ControlSearch
          }
        ]
      });
      setAddressIndex(0);
      setVulnerabilitiesId(0);
      sessionStorage.removeItem('AddNewCustomer');
      sessionStorage.removeItem('SearhResult');
      sessionStorage.removeItem('ConsumerId');
      setRequired(false);
    }
  }, [ControlSearch]);

  useEffect(() => {
    var Control = sessionStorage.getItem('UserTypeControl');
    var Control1 = 0;
    if (Control === undefined || Control === null) {
      sessionStorage.setItem('UserTypeControl', SessionUser.UserType);
      Control1 = SessionUser.UserType;
    }
    if (Control1 === 1) {
      setJobSearchPopup(true);
    }
    var ConsumerScreenLocal = getConsumerScreen();
    var ConsumerAddressScreenLocal = getConsumerAddressScreen();

    if (ConsumerScreenLocal !== null) {
      setState(ConsumerScreenLocal);
    }
    if (ConsumerAddressScreenLocal !== null) {
      setStateAddress(ConsumerAddressScreenLocal);
    }
  }, []);

  const DeletePhoneItem = (event, Phone) => {
    const selectedChangePhones = formData.Phones;
    var filteredIndex = selectedChangePhones.findIndex(x => x.Phone === Phone);
    selectedChangePhones.splice(filteredIndex, 1);
    setFormdata({ ...formData, Phones: selectedChangePhones });
  };
  const setAddressPopupEdit = (event, row, index) => {
    setAddressIndex(index);
    setAddressPopup(false);
    GetDistrictDataForPopUp(row.City, row.regionName == "" ? "0" : row.regionName);
    GetPostCode(row.regionName == "" ? "0" : row.regionName, row.City, '0');
  };

  const getAddressHeader = row => {
    var Label = t('lblPrimary');
    if (row.PrimaryAddress === true) {
      Label = t('lblPrimary');
    } else {
      Label = t('lblSecondary');
    }
    var ReturnValue = (
      <Chip
        style={{ color: row.PrimaryAddress === true ? 'green' : 'red' }}
        icon={<HomeIcon />}
        label={Label}
      />
    );
    return ReturnValue;
  };

  const GetConsumerAssetsData = () => {
    setLoading2(true);
    axios
      .get('/GetConsumerAssets/' + formData.ConsumerId)
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setAssets([]);
        } else {
          setAssets(ResponseData);
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetConsumerFileData = () => {
    setLoading2(true);
    axios
      .get('/GetConsumerFiles/' + formData.ConsumerId + '/' + SessionUser.ServiceShopId + '/' + SessionUser.Role)
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setFiles([]);
        } else {
          setFiles(ResponseData);
        }
        setLoading2(false);
        setConsumerFilePopup(true);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetConsumerAssets = () => {
    setLoading2(true);
    axios
      .get('/GetConsumerAssets/' + formData.ConsumerId)
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setAssets([]);
        } else {
          setAssets(ResponseData);
        }
        setAssetPopup(true);
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };
  const handleChangeAddressPrimary = (event, AddressIndex) => {
    var Value;
    if (event.target.type === 'checkbox') {
      Value = event.target.checked;
    } else {
      Value = event.target.value;
    }
    var Data = [...formData.Addresses];

    if (Data.length === 1) {
      Value = true;
    }

    if (Value == false) {
      setresponseMessage({
        ErrorCode: '10',
        ErrorDescription: t('lblPrimaryAddressWarning')
      });
      setUyari(true);
      setUyariTip('warning');
      return;
    }

    Data.forEach(item => {
      item.PrimaryAddress = false;
    });

    var AddressItem = { ...Data[AddressIndex], [event.target.id]: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
    if (Value) {
      setconsumerAddressPrimarySecondary(t('lblPrimary'));
    } else {
      setconsumerAddressPrimarySecondary(t('lblSecondary'));
    }
  };
  const handleConsumerWorkCase = (value) => {
    setLoading2(true);
    axios
      .get(`/GetConsumerWorkCase/` + formData.ConsumerId + '/' + SessionUser.ServiceShopId + '/' + SessionUser.Role)
      .then(response => {
        if (response.data.length > 0) {
          setWorkCaseData(response.data);
          setinitialRows(response.data);
          if (value === 0) {
            setWorkCasePopup(false);
          } else {
            setWorkCasePopup(true);
          }
        }
        //setWorkCaseNumber(response.data.length);
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };


  const SaveCompensation = (ReceiptNo) => {
    const dataBody = {
      WorkOrderId: ReceiptNo,
    };
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetCompensationForPotentialLiability', dataBody, dataConfig)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        if (res[0].ErrorCode === 0) {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('success_message')
          });
          setUyariTip('success');
          setUyari(true);
        } else {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: res[0].ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        }
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        setUyari(true);
      });
  }

  const handlePotentialLiabiltiy = event => {
    event.persist();
    var PotentialLiabiltiy = 0;
    if (event.target.checked) {
      PotentialLiabiltiy = 1;
    } else {
      PotentialLiabiltiy = 0;
    }

    let job = NewWorkCaseData;
    job = {
      ...job,
      PotentialLiabiltiy: PotentialLiabiltiy
    };
    setNewWorkCaseData(job);
  };

  const setIssue = param => {
    var Data = { ...NewWorkCaseData };
    setRequiredWorkCase(false);
    setRequiredWorkCaseComment(false);
    Data.Issue = param.Dsc;
    Data.IssueId = param.Id;
    Data.Comment = param.Dsc + '  ';
    setIssueTypeId(param.Type);

    // if (param.Type === 10) {
    //   setInsertAssetPopup(true)
    //   setNewWorkCasePopup(false)
    // }
    setNewWorkCaseData(Data);
  };
  const setRetailer = param => {
    var Data = { ...NewWorkCaseData };
    Data.Retailer = param.Dsc;
    Data.RetailerId = param.Id;
    setNewWorkCaseData(Data);
  };
  const setDistributor = param => {
    var Data = { ...NewWorkCaseData };
    Data.Distributor = param.Dsc;
    Data.DistributorId = param.Id;
    setNewWorkCaseData(Data)
  };
  const setProduct = param => {
    var Data = { ...NewWorkCaseData };
    Data.Product = param.Dsc;
    Data.ProductId = param.Id;
    Data.SKU = param.ModelCode;
    setModelCode(param?.ModelCode);
    setNewWorkCaseData(Data);
    setNewAssetChosen(param.Id > 0);
  };

  useEffect(() => {
    if (SearchStr?.length > 0 && !isNewCustomer) {
      const SearchJson = JSON.parse(SearchStr);
      setSearchList(SearchJson);
      setFormdata(SearchJson);
      GetSecretNote(SearchJson.ConsumerId);
      if (SearchJson.Addresses[AddressIndex]?.City) {
        GetDistrictDataForPopUp(SearchJson.Addresses[AddressIndex]?.City, SearchJson.Addresses[AddressIndex]?.Region);

        if (SearchJson.Addresses[AddressIndex]?.District) {
          GetNeighborhood(
            SearchJson.Addresses[AddressIndex]?.City,
            SearchJson.Addresses[AddressIndex]?.District
          );
          if (SearchJson.Addresses[AddressIndex]?.Region) {
            GetPostCode(
              SearchJson.Addresses[AddressIndex]?.Region,
              SearchJson.Addresses[AddressIndex]?.City,
              SearchJson.Addresses[AddressIndex]?.District
            );
          }
        }
      }
    }
  }, [SearchStr]);

  useEffect(() => {
    GetRegionRequest();
    GetServiceShops();
    GetPhoneTypes();
    GetAddressTypes();
    GetVulnerabilitiesData();
    GetConsumerTitlesData();
    GetPlace();
    GetWarranty();
    GetCountryData();
    GetCustomerType();
  }, [locale]);

  useEffect(() => {
    setRows(WorkCaseData);
  }, [WorkCaseData]);
  useEffect(() => {
    const stored = sessionStorage.getItem('SearhResult');
    if (!stored) return;
    try {
      const result = JSON.parse(stored);
      // GetSearchMain’den gelen WorkCaseCount’u burada alıyoruz
      if (result.WorkCaseCount !== undefined && result.WorkCaseCount !== null) {
        setWorkCaseNumber(result.WorkCaseCount);
      }
    } catch (e) {
      console.error('SearhResult parse error', e);
    }
  }, []);


  useEffect(() => {
    axios
      .get('/GetSiriusCloseStatus')
      .then(response => {
        const Deger = response.data;


        if (Deger.length > 0) {
          // setStatusData(Deger);
          var allServiceShop = { StatusId: 0, FieldText: t('lblAllStatus') };
          var subServiceShopControlNew = [...Deger];
          subServiceShopControlNew.push(allServiceShop)
          setStatusData(subServiceShopControlNew.sort((a, b) => (a.StatusId > b.StatusId ? 1 : -1)));
          var Value = Deger.filter(x => x.MobileStatusId === 1);
          setStatusSeacrh(Value[0].StatusId);
        }

        setLoadingControl(false);
      })
      .catch(error => {
        setLoadingControl(false);
      });
    //setSonDurum(SonlandirData[0]?.LatestStatus || '0');
  }, [SessionUser.ServiceShopId]);

  const GetRegionRequest = () => {
    setLoading2(true);
    axios
      .get('/GetRegionRequest/')
      .then(response => {
        setRegionData(response.data);
        if (response.data.length == 1) {
          GetCityRequest();
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetCity = (event, AddressIndex, newInputValue) => {
    var Value = newInputValue;
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[AddressIndex], Region: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });

    if (RegionData.includes(newInputValue)) {
      GetCityRequestByRegion(newInputValue);
    } else {
      changeRegionAndCityData(selected);
    }
  };

  const GetCityRequestByRegion = regionName => {
    setLoading2(true);
    axios
      .get('/GetCityRequestByRegion/' + regionName)
      .then(response => {
        setCityData(response.data);
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetCityRequest = () => {
    setLoading2(true);
    axios
      .get('/GetCityRequest/')
      .then(response => {
        setCityData(response.data);
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetDistrictRequest = (event, AddressIndex, newInputValue) => {
    var Value = newInputValue;
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[AddressIndex], City: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
    //if (!CityData.includes(newInputValue)) {
    var Data = [...formData.Addresses];
    if (Data[AddressIndex].District != "") {
      var AddressItem = { ...Data[AddressIndex], District: '', PostCode: '', Neighborhood: '' };
      Data[AddressIndex] = AddressItem;
      setFormdata({ ...formData, Addresses: Data });
    }
    //}
    if (CityData.includes(newInputValue)) {
      GetPostCode(AddressItem.Region == "" ? "0" : AddressItem.Region, newInputValue, '0');
      GetDistrictData(newInputValue, AddressItem.Region == "" ? "0" : AddressItem.Region);
      GetNeighborhood(newInputValue, '0')
    }

  };
  // const GetDistrictDatabyPostCode = PostCode => {
  //   setLoading2(true);
  //   axios
  //     .get('/GetDistrictRequestByPostCode/' + PostCode)
  //     .then(response => {
  //       setDistrictData(response.data);

  //       setLoading2(false);
  //       return response.data;



  //     })
  //     .catch(error => {
  //       setLoading2(false);
  //     });
  // };
  const GetDistrictData = (cityName, regionName) => {
    setLoading2(true);
    axios
      .get('/GetDistrictRequest/' + cityName + '/' + regionName)
      .then(response => {
        setDistrictData(response.data);
        var Data = [...formData.Addresses];
        if (Data[AddressIndex].District != "") {
          var AddressItem = { ...Data[AddressIndex], District: '', PostCode: '', Neighborhood: '' };
          Data[AddressIndex] = AddressItem;
          setFormdata({ ...formData, Addresses: Data });
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetDistrictDataForPopUp = (cityName, regionName) => {
    setLoading2(true);
    axios
      .get('/GetDistrictRequest/' + cityName + '/' + regionName)
      .then(response => {
        setDistrictData(response.data);
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const ChangeDistrict = (event, AddressIndex, newInputValue) => {
    var Value = newInputValue;
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[AddressIndex], District: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });

    Data = [...formData.Addresses];
    if (Data[AddressIndex].PostCode != "") {
      var AddressItem = { ...Data[AddressIndex], PostCode: '' };
      Data[AddressIndex] = AddressItem;
      setFormdata({ ...formData, Addresses: Data });
    }
    if (Data[AddressIndex].Neighborhood != "") {
      var AddressItem = { ...Data[AddressIndex], Neighborhood: '' };
      Data[AddressIndex] = AddressItem;
      setFormdata({ ...formData, Addresses: Data });
    }

    // if (DistrictData.includes(newInputValue)  ) {
    //   if(!PostCodefiltered){
    //   GetNeighborhood(AddressItem.City, AddressItem.District);
    //   GetPostCode(AddressItem.Region==""?"0":AddressItem.Region, AddressItem.City==""?"0":AddressItem.City, AddressItem.District);
    //   GetCityRequestByDistrict(AddressItem.District);
    //   setDistrictFiltered(true);
    //   }
    // }
    // else{

    //   setDistrictFiltered(false );
    //   GetCityRequest();
    //   GetPostCode('0', '0', '0');
    // }
    if (DistrictData.includes(newInputValue)) {
      GetNeighborhood(AddressItem.City, newInputValue);
      GetPostCode(AddressItem.Region, AddressItem.City, newInputValue);
    }

  };

  const ChangeNeighborhood = (event, AddressIndex, newInputValue) => {
    var Value = newInputValue;
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[AddressIndex], Neighborhood: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
  };

  const GetNeighborhood = (cityName, DistrictName) => {

    if (DistrictName === '') {
      DistrictName = '0';
    }
    if (cityName === '') {
      cityName = '0';
    }

    axios
      .get('/GetNeighborhoodsRequest/' + cityName + '/' + DistrictName)
      .then(response => {
        setNeighborhoodData(response.data);
      })
      .catch(error => { });
  };

  const ChangePostCode = (event, AddressIndex, newInputValue) => {
    var Value = newInputValue;
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[AddressIndex], PostCode: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
    // if (PostCodeData.includes(newInputValue) ) {
    //   if(!Districtfiltered){
    //   GetCityRequestByDistrictbyPostCode(AddressItem.PostCode);
    //   GetDistrictDatabyPostCode(AddressItem.PostCode);
    //   var Data = [...formData.Addresses];

    //   var AddressItem = { ...Data[0], City: '',District: '' };
    //   Data[0] = AddressItem;
    //   setFormdata({ ...formData, Addresses: Data });

    //   setPostCodeFiltered(true);
    //   }
    // }
    // else{

    //   setPostCodeFiltered(false );
    //   GetCityRequest();
    //   GetDistrictData("");
    // }

  };

  const GetPostCode = (regionName, cityName, DistrictName) => {
    if (!regionName) {
      regionName = '0'
    }
    setLoading2(true);
    axios
      .get('/GetPostCodeRequest/' + regionName + '/' + cityName + '/' + DistrictName)
      .then(response => {
        let result = []
        if (response.data != '') {
          response.data.map(x => result.push(x.PostCode))
          setPostCodeData(result);
          setLoading2(false);
        }
        else {
          setPostCodeData([]);
          setLoading2(false);
        }

      })
      .catch(error => { setLoading2(false); });
  };

  const handleSendCostumerSecretNote = () => {
    setRequiredForInternalNotes(true);
    setSecretNote('');
    if (
      formData.ConsumerId === 0 ||
      formData.ConsumerId === undefined ||
      VulnerabilitiesId === 0
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      setRequired(true);
      return;
    }
    if (SecretNote.length === 0) {
      setresponseMessage({
        ErrorCode: '10',
        ErrorDescription: t('yorum_yaziniz')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    const data = {
      ConsumerId: formData.ConsumerId,
      EmployeeId: parseInt(SessionUser.TechnicianId) || 1,
      SecretNote: SecretNote || '',
      VulnerabilitiesId: VulnerabilitiesId || 0
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading2(true);
    axios
      .post('/SetConsumerSecretNote', data, config)
      .then(response => {
        setLoading2(false);
        let ResponseData = response.data;
        if (parseInt(ResponseData.ErrorCode) !== 0) {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        } else {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('success');
          setUyari(true);
          GetSecretNote(formData.ConsumerId);
        }
      })
      .catch(error => {
        setLoading2(false);
        setresponseMessage({
          ErrorCode: '10',
          ErrorDescription: t('Error') + error.message
        });
        setUyariTip('error');
        setUyari(true);
      });
  };
  const NewAddressCheck = () => {
    let uyari = false;
    if (
      //     formData.Addresses[AddressIndex]?.AddressItem?.length > 0 ||
      formData.Addresses[AddressIndex]?.City?.length > 0
    ) {
      if (
        //    formData.Addresses[AddressIndex]?.AddressItem?.length === 0 ||
        formData.Addresses[AddressIndex]?.City?.length === 0
      ) {
        uyari = true;
      }
    }
    return uyari;
  };
  const SaveConsumer = () => {
    if (
      // formData.Title === 0 ||
      formData.CustomerTypeId === 0 ||
      // formData.FirstName.length === 0 ||
      formData.LastName.length === 0
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequired(true);

      setUyari(true);
      return;
    }
    if (SessionUser.TenantId == 49 && (formData.Addresses[AddressIndex]?.PostCode?.length === 0 || formData.Addresses[AddressIndex]?.PostCode == undefined)) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Check PostCode')
      });
      setUyariTip('error');
      setUyari(true);
      setRequired(true);
      return;
    }


    let uyari = false;
    if (formData.Phones?.length === 0) {
      if (
        newtel === '' ||
        newtel === undefined ||
        ParamPhonesType === 0 ||
        ParamPhonesType === undefined ||
        ParamPhonesType === '' ||
        newtel.length === countryCode.length
      ) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        uyari = true;
        setRequired(true);
      } else {
        var PhoneType = PhoneTypes.filter(item => item.Id === ParamPhonesType);

        axios
          .get('/CheckPhoneNumber/' + newtel)
          .then(response => {

            let ResponseData = response.data;
            // If the user select CustomerType 'Return' as customerType (9 or 10)
            // There will be a an exception in which 
            // we wont check if the user have already that phone number
            if (formData.CustomerTypeId == 9 || formData.CustomerTypeId == 10) {
              ResponseData = ""
            }
            if (ResponseData.length !== 0) {
              setresponseMessage({
                ErrorCode: 10,
                ErrorDescription:
                  ' Id: ' + ResponseData[0].ConsumerId + ' ' +
                  ResponseData[0].Title + ' ' +
                  ResponseData[0].FirstName + ' ' +
                  ResponseData[0].MiddleName + ' ' +
                  ResponseData[0].LastName
              });
              setUyariTip('error');
              setUyari(true);
              setRequired(true);
            }
            else {
              var Data = {
                PhoneId: 0,
                Phone: newtel,
                PhoneTypeId: ParamPhonesType,
                PhoneType: PhoneType[0].Dsc
              };
              formData.Phones.push(Data);
              setNewTel(countryCode);

              if (emailError) {
                uyari = true;
              }
              if (NewAddressCheck()) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblMustFieldControl')
                });
                setUyariTip('error');
                uyari = true;
                setRequiredAddress(true);
              }
              if (
                // formData.Title === 0 ||
                formData.CustomerTypeId === 0 ||
                // formData.FirstName.length === 0 ||
                formData.LastName.length === 0
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblMustFieldControl')
                });
                setUyariTip('error');
                uyari = true;
                setRequired(true);
              }

              if (SessionUser.TenantId == 49 && (formData.Addresses[AddressIndex]?.PostCode?.length === 0 || formData.Addresses[AddressIndex]?.PostCode == undefined)) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('Check PostCode')
                });
                setUyariTip('error');
                uyari = true;
                setRequired(true);
              }

              if (uyari) {
                setUyari(true);
                return;
              }
              else {
                if (
                  // formData.Title === 0 ||
                  formData.CustomerTypeId === 0 ||
                  // formData.FirstName.length === 0 ||
                  formData.LastName.length === 0
                ) {
                  setresponseMessage({
                    ErrorCode: 10,
                    ErrorDescription: t('lblMustFieldControl')
                  });
                  setUyariTip('error');
                  setRequired(true);

                  setUyari(true);
                  return;


                }

                if (SessionUser.TenantId == 49 && (formData.Addresses[AddressIndex]?.PostCode?.length === 0 || formData.Addresses[AddressIndex]?.PostCode == undefined)) {
                  setresponseMessage({
                    ErrorCode: 10,
                    ErrorDescription: t('Check PostCode')
                  });
                  setUyariTip('error');
                  setUyari(true);
                  setRequired(true);
                  return;
                }

                confirmAlert({
                  message: t('lblConfirm'),
                  buttons: [
                    {
                      label: t('Evet'),
                      onClick: () => SaveConsumerYes()
                    },
                    {
                      label: t('Hayir'),
                      onClick: () => {
                        return;
                      }
                    }
                  ]
                });
              }
            }
          })
      }
    }
    else {
      confirmAlert({
        message: t('lblConfirm'),
        buttons: [
          {
            label: t('Evet'),
            onClick: () => SaveConsumerYes()
          },
          {
            label: t('Hayir'),
            onClick: () => {
              return;
            }
          }
        ]
      });
    }
  };
  const SaveConsumerYes = () => {
    if (

      // formData.Title === 0 ||
      formData.CustomerTypeId === 0 ||
      // formData.FirstName.length === 0 ||
      formData.LastName.length === 0
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');

      setRequired(true);

      setUyari(true);
      return;


    }



    const dataBody = { ...formData };
    dataBody.EmployeeId = SessionUser.TechnicianId;

    if (dataBody.Country === '') {
      dataBody.Country = SessionUser.TenantCode;
    }

    dataBody.Addresses = dataBody.Addresses.map(address => {
      // Eğer Type 0 ise, kopyasını oluşturup Type'ı 1 yap
      if (address.AddressTypeId === 0) {
        return { ...address, AddressTypeId: 1 };
      }
      // Type 0 değilse değişiklik yapma
      return address;
    });
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetConsumer', dataBody, dataConfig)
      .then(response => {
        var ResponseData = response.data[0];
        if (ResponseData.ErrorCode === '0') {
          setFormdata(ResponseData);
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: t('success_message')
          });
          setAddressIndex(
            ResponseData.Addresses.length > AddressIndex ? AddressIndex : 0
          );
          setUyariTip('success');
          setUyari(true);
          sessionStorage.removeItem('SearhResult');
          sessionStorage.setItem('SearhResult', JSON.stringify(ResponseData));
          sessionStorage.removeItem('ConsumerId');
          sessionStorage.setItem('ConsumerId', ResponseData.ConsumerId);
        } else {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        }
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });
  };

  const SaveWorkCase = () => {
    setisButtonDisabled(true);

    let uyari = false;
    const ControlIssueTypeId = [3, 4, 5, 2, 7, 11];
    // const ControlIssueTypeId = [3, 4, 5, 2, 7, 10, 11];

    if (
      retailerControlTenantId.includes(SessionUser.TenantId) && (NewWorkCaseData.RetailerId === 0 ||
        NewWorkCaseData.RetailerId === undefined ||
        NewWorkCaseData.Retailer === "" ||
        NewWorkCaseData.Retailer === undefined
      )
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: 'Retailer field is required'
      });
      setUyariTip('error');
      setRequired(true);
      uyari = true;
    }

    if (IssueTypeId == 7 || IssueTypeId == 10 || IssueTypeId == 14) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Workcase cannot be created from this module with this application type.')
      });
      setUyariTip('error');
      setRequired(true);
      uyari = true;
    }

    if (IssueTypeId == 10 && NewWorkCaseData.SerialNr != undefined && NewWorkCaseData.SerialNr.length <= 0) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblSerialNumberControl')
      });
      setUyariTip('error');
      setRequired(true);
      uyari = true;
    }

    if ((SessionUser.TenantId == 52 || SessionUser.TenantId == 11) && (NewWorkCaseData.DistributorId == undefined || NewWorkCaseData.DistributorId == 1)) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Please select Distributor')
      });
      setUyariTip('error');
      setRequired(true);
      uyari = true;
    }

    if (formData.ConsumerId === 0 || formData.ConsumerId === undefined) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequired(true);
      uyari = true;
    }

    if (
      formData.Addresses?.length < 1 ||
      formData.Addresses === undefined ||
      formData.Addresses[0].AddressId === 0
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustAddressFieldControl')
      });
      setUyariTip('error');
      uyari = true;
    }
    if (NewWorkCaseData.WarrantyDate && !moment(NewWorkCaseData.WarrantyDate).isValid()) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequiredWorkCase(true);
      uyari = true;
    }
    if (
      (NewWorkCaseData.ProductId === 0 ||
        NewWorkCaseData.ProductId === undefined) &&
      !ControlIssueTypeId.includes(parseInt(IssueTypeId))
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequiredWorkCase(true);
      uyari = true;
    }
    if (
      (NewWorkCaseData.IssueId === 0 ||
        NewWorkCaseData.IssueId === undefined) &&
      !ControlIssueTypeId.includes(parseInt(IssueTypeId))
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequiredWorkCase(true);
      uyari = true;
    }
    if (
      (NewWorkCaseData.WarrantyTypeId === 0 ||
        NewWorkCaseData.WarrantyTypeId === undefined) &&
      !ControlIssueTypeId.includes(parseInt(IssueTypeId))
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequiredWorkCase(true);
      uyari = true;
    }

    if (
      NewWorkCaseData.Comment === '' ||
      NewWorkCaseData.Comment === undefined
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequiredWorkCaseComment(true);
      uyari = true;
    }
    if (uyari) {
      setUyari(true);
      setisButtonDisabled(false);
      return;
    }
    const dataBody = { ...NewWorkCaseData };
    dataBody.EmployeeId = SessionUser.TechnicianId;
    dataBody.ConsumerId = formData.ConsumerId;
    dataBody.Source = 1;

    dataBody.Barcode = NewWorkCaseData.SerialNr ? NewWorkCaseData.SKU + NewWorkCaseData.SerialNr : null;

    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetWorkCase', dataBody, dataConfig)
      .then(response => {
        var ResponseData = response.data;
        if (ResponseData.ErrorCode === "1000") {
          setresponseMessage({
            ErrorCode: 1000,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        }
        else {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('success');
          setUyari(true);
          setNewWorkCaseData(DefaultWorkCase);
          var WorkCaseCountParam = formData.WorkCaseCount ?? 0;
          const Workcasecounter = sessionStorage.getItem('SearhResult');
          let jsonWorkcasecounter = JSON.parse(Workcasecounter);
          jsonWorkcasecounter['WorkCaseCount'] = WorkCaseCountParam + 1;
          sessionStorage.setItem(
            'SearhResult',
            JSON.stringify(jsonWorkcasecounter)
          );

          setNewWorkCasePopup(false);

          if (IssueTypeId === 10) {
            setSaveWorkOrderId(ResponseData.WorkOrderId)
            // setInsertAssetPopup(true)
            // setFormdata({ ...formData, AssetCount: formData.AssetCount + 1 });
            setFormdata({ ...formData, WorkCaseCount: WorkCaseCountParam + 1 });
          }
          else if (IssueTypeId === 14) {
            setSaveWorkOrderId(ResponseData.WorkOrderId)
            setInsertAssetDaysPopup(true)
            setFormdata({ ...formData, AssetCount: formData.AssetCount + 1 });
          }
          else {
            setFormdata({ ...formData, WorkCaseCount: WorkCaseCountParam + 1 });
          }
          if (!ControlIssueTypeId.includes(parseInt(IssueTypeId))) {
            sessionStorage.removeItem('WorkOrderId');
            sessionStorage.setItem('WorkOrderId', ResponseData.WorkOrderId);
            getTasksRequest(ResponseData.WorkOrderId);
            history.push(`/WorkOrder/${ResponseData.WorkOrderId}/summary`);
          }

          if (NewWorkCaseData.PotentialLiabiltiy == 1) {
            SaveCompensation(ResponseData.WorkOrderId);
          }
        }
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });

    setTimeout(() => setisButtonDisabled(false), 10000);
  };

  const SetWorkOrderDetail = (event, row) => {
    getTasksRequest(row.WorkOrderId);
    history.push(`/WorkOrder/${row.WorkOrderId}/summary`);
  };

  const SetWorkOrderTaskDetail = (Selected) => {
    const rowIndex = Selected.rowIds[0] - 1;
    var Search = TasksData[rowIndex]?.lblWorkOrderId;

    axios
      .get('/GetConsumerByWorkOrderId/' + Search + '/' + SessionUser.ServiceShopId + '/' + SessionUser.Role)
      .then(res => {
        const response = JSON.stringify(res.data[0]);
        if (response === undefined) {

        } else {
          sessionStorage.removeItem('SearhResult');
          sessionStorage.setItem('SearhResult', response);
          sessionStorage.removeItem('ConsumerId');
          sessionStorage.setItem('ConsumerId', res.data[0].ConsumerId);
          getTasksRequest(Search);
          history.push(`/WorkOrder/${Search}/summary`);
        }

      })
      .catch(err => { });

  };

  function handleCloseDialog() {
    setOpenMaterialOrder(false);
  }

  const SaveGdpr = () => {
    GdprData.ConsumerId = formData.ConsumerId;
    GdprData.EmployeeId = SessionUser.TechnicianId;

    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetGdprRequest', GdprData, dataConfig)
      .then(response => {
        setUyariTip('success');
        setUyari(true);
        setGdprPopup(false);
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });
  };

  const CustomerAnonymyze = () => {

    var ConsumerId = formData.ConsumerId;
    var EmployeeId = SessionUser.TechnicianId;

    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .get(`/CustomerAnonymyze/${ConsumerId}/${EmployeeId}`, dataConfig)
      .then(response => {
        setUyariTip('success');
        setUyari(true);
        setAnonymyzePopup(false);
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });
  };

  const GetWorkCaseDetailOrder = item => {
    setWorkOrderData(item.WorkOrders);
    setWorkCasePopup(false);
    setWorkOrderPopup(true);
  };

  const setNewWorkCaseAssets = item => {
    if (item != null) {
      setModelCode(item.ProductCode);
      setAssetChosen(true);
      setLoading2(true);
      axios
        .get(
          '/GetAssetWarrantyDate/' +
          item.ProductId +
          '/' +
          item.ProductionYear +
          '/' +
          item.ProductionMonth +
          '/' +
          item.SerialNr +
          '/' +
          item.WarrantyId
        )
        .then(response => {
          setNewWorkCaseData({
            ...NewWorkCaseData,
            ProductId: item.ProductId,
            SKU: item.ProductCode,
            WarrantyDate: response.data != null && response.data != "" && response.data != undefined
              ? moment(response.data).format('YYYY.MM.DD')
              : moment(item.WarrantyDate).format('YYYY.MM.DD'),
            ProductionYear: item.ProductionYear,
            ProductionMonth: item.ProductionMonth,
            SerialNr: item.SerialNr,
            Retailer: item.Retailer,
            RetailerId: item.RetailerId
          });
          setWarrantyDateDisable(true);
          setLoading2(false);
        })
        .catch(error => {
          setLoading2(false);
        });
    } else {
      setWarrantyDateDisable(false);
      setAssetChosen(false);
      setNewWorkCaseData(DefaultWorkCase);
    }
  };
  // const GetCityRequestByDistrictbyPostCode  = PostCode =>  {
  //     setLoading2(true);
  //     axios
  //       .get('/GetCityRequestByPostCode/'+PostCode)
  //       .then(response => {
  //         setCityData(response.data);

  //         setLoading2(false);
  //       })
  //       .catch(error => {
  //         setLoading2(false);
  //       });
  //   };

  const handleFileOpen = (event, Id, FileName) => {
    setLoading2(true);
    const config = {
      responseType: 'blob'
    };
    let newWindow = window.open();
    axios
      .get('/FileImportExport/SiriusFileDetail/' + Id, config)
      .then(response => {
        // openBlob(response.data, FileName);
        var fileURL = URL.createObjectURL(response.data);
        newWindow.location = fileURL;
        newWindow.document.title = FileName;
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const DeleteCostumerSecretNote = Id => {
    SetSecretNotePopUp(false);
    confirmAlert({
      message: t('lblConfirm'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => DeleteCostumerSecretNoteYes(Id)
        },
        {
          label: t('Hayir'),
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const DeleteCostumerSecretNoteYes = Id => {
    setLoading2(true);
    axios
      .get('/DeleteConsumerSecretNote/' + Id)
      .then(response => {
        GetSecretNote(formData.ConsumerId);
        setLoading2(false);
        SetSecretNotePopUp(true);
      })
      .catch(error => {
        setLoading2(false);
      });
  };
  const handleChangeStatusSearch = event => {
    setStatusSeacrh(event.target.value);
  };

  const handleChangeServiceShopSearch = event => {
    setServiceShopId(event.target.value);
  };

  const SetCountry = (code, index) => {
    setSelected(code);
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[index], Country: code };
    Data[index] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
    // setCityData([]); 
    // changeRegionAndCityData(code);
  };

  function changeRegionAndCityData(cityCode) {
    axios
      .get('/GetRegionRequestByCountryCode/' + cityCode)
      .then(response => {
        if (
          response.data.length == 0 ||
          (response.data.length == 1 && !response.data[0])
        ) {
          setRegionData([]);
          axios
            .get('/GetCityRequestByCountryCode/' + cityCode)
            .then(response2 => {
              if (
                response2.data.length == 0 ||
                (response2.data.length == 1 && !response2.data[0])
              ) {
                setCityData([]);
              } else {
                setCityData(response2.data);
              }
              setLoading2(false);
            })
            .catch(error => {
              setLoading2(false);
            });
        } else {
          setCityData([]);
          setRegionData(response.data);
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  }

  const GetGdpr = () => {
    if (formData.ConsumerId === 0 || formData.ConsumerId === undefined) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      setRequired(true);
      return;
    }
    setLoading2(true);
    axios
      .get('/GetGdprRequest/' + formData.ConsumerId)
      .then(response => {
        setGdprData(response.data);
        setGdprPopup(true);
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  // const GetConsumerInformation = () => {
  //   axios
  //     .get('/GetConsumerInformation/' + formData.ConsumerId)
  //     .then(response => {
  //       setInformationData(response.data);
  //       setInformationPopup(true);
  //       //setLoading2(false);
  //     })
  //     .catch(error => {
  //       setLoading2(false);
  //     });
  // };

  const handleChangeWarrantyTypeId = e => {
    let data = e.target.value;
    var WarrantyGroupId = WarrantyData.filter(x => x.WarrantyId === data);
    if (WarrantyGroupId[0].WarrantyGroupId === 6) {
      const today = moment(new Date()).format('YYYY-MM-DD');
      setWarrantyDateDisable(true);
      setNewWorkCaseData({
        ...NewWorkCaseData,
        WarrantyTypeId: data,
        WarrantyDate: today
      });
    } else {
      setWarrantyDateDisable(false);
      setNewWorkCaseData({
        ...NewWorkCaseData,
        WarrantyTypeId: data
      });
    }




    setSelectedWarrantyType(data);
  };




  const handleChangeStartDateSearch = e => {
    setStartDateSearch(e);
  };
  const handleChangeEndDateSearch = e => {
    setEndDateSearch(e);
  };

  const GetTasksData = () => {
    if (isTaskCooldownActive) {
      setResponseType('warning');
      setResponseDsc(t('lblCooldownWait', { seconds: taskRemainingSeconds }));
      setOpenSnackbar(true);
      return;
    }
    // setTasksData([]);
    // setTasksScreenData([]);
    // setDetailedExcelData([])
    // setLoading2(true);

    const dateDifference = moment(EndDateSearch).diff(moment(StartDateSearch), 'days');

    if (dateDifference > 90) {
      // setLoading2(false);
      return;
    }

    var StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    var EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    var statu = [];
    selectedValues.map((i) => {
      statu.push(i.StatusId)
    });
    var taskScreenResult = []
    triggerTaskCooldownByDateRange(StartDateSearch, EndDateSearch);
    var result = dispatch(getFilteredTasksRequest(tasksFilterModel))
  };

  const DeleteAddress = Id => {
    const selected = formData.Addresses;
    var filteredIndex = selected.filter(x => x.AddressId === Id);
    var ControlAddress = filteredIndex.filter(x => x.PrimaryAddress === true);
    if (ControlAddress.length > 0) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblAddressPrimaryError')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    } else {
      setAddressPopup(false);
      confirmAlert({
        message: t('lblConfirm'),
        buttons: [
          {
            label: t('Evet'),
            onClick: () => DeleteAddressYes(Id)
          },
          {
            label: t('Hayir'),
            onClick: () => {
              return;
            }
          }
        ]
      });
    }
  };

  const DeleteAddressYes = Id => {
    setLoading2(true);
    axios
      .get('/DeleteAddress/' + Id)
      .then(response => {
        const selected = formData.Addresses;
        var filteredIndex = selected.findIndex(
          x => parseInt(x.AddressId) === parseInt(Id)
        );
        if (filteredIndex > -1) {
          selected.splice(filteredIndex, 1);
          setFormdata({ ...formData, Addresses: selected });
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const SearchGoogleAddress = () => {
    setLoading2(true);
    setGoogleAddressSearchResult([]);
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    var Request = {
      Address: addressGoogleSearch
    };
    axios
      .post('/GoogleSearchLocation', Request, dataConfig)
      .then(response => {
        if (response.data.length === 0) {
          setGoogleAddressSearchResult([]);
        } else {
          setGoogleAddressSearchResult(response.data);
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const SearchAddress = () => {
    setAddressSearchResult([]);
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios
      .post('/SearchLocation', addressSearch, dataConfig)
      .then(response => {
        //setAddressSearchResult(response.data)
        if (response.data.length === 0) {
          setAddressSearchResult([]);
        } else {
          setAddressSearchResult(
            response.data.map(w => {
              return {
                id: w.Id,
                Region: w.Region,
                City: w.City,
                District: w.District,
                PostCode: w.PostCode,
                Neighborhood: w.Neighborhood
              };
            })
          );
        }
      })
      .catch(error => { });
  };

  const SetAdressWithSearchedResult = selectedRow => {
    const rowIndex = addressSearchResult.findIndex(
      x => parseInt(x.id) === parseInt(selectedRow)
    );
    const item = addressSearchResult[rowIndex];
    var Data = [...formData.Addresses];
    var AddressItem = {
      ...Data[AddressIndex],
      Region: item.Region,
      City: item.City,
      District: item.District,
      PostCode: item.PostCode,
      Neighborhood: item.Neighborhood
    };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
    setAddressSearchPopup(false);
  };

  const requestSearch = searchedVal => {
    const filteredRows = initialRows.filter(item =>
      sc(
        item.WorkCaseId +
        item.Status +
        item.CallDate +
        item.WarrantyType +
        item.Issue +
        item.ProductCode +
        item.Barcode +
        item.Product,
        searchedVal
      )
    );
    setWorkCaseData(filteredRows);
  };
  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };

  function openFeedbackPopupX() {
    if (formData.ConsumerId != 0) {

      setLoading2(true);
      const startDate = moment()
        .subtract(1, 'years')
        .format('DD.MM.yyyy');
      const endDate = moment().format('DD.MM.yyyy');
      axios
        .get(
          '/GetTasksDataCustomerFeedbackForServiceShop/' +
          formData.ConsumerId +
          '/' +
          startDate +
          '/' +
          endDate
        )
        .then(response => {
          setFeedbackDataList(response.data);
          setOpenFeedbackPopup(true);
          setLoading2(false);
        })
        .catch(error => { });
    } else {
    }
  }

  const AddAddress = (formatted_address, lat, lng, place_id) => {
    setLoading2(true);
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    var Request = {
      Address: place_id
    };
    axios
      .post('/GoogleSearchLocationDetail', Request, dataConfig)
      .then(response => {
        var postal_code = '';
        var No = '';
        var country = '';
        var Neighborhood = '';
        var Street = '';
        var DoorNr = '';
        var City = '';
        var District = '';
        var State = '';
        var Region = '';
        if (SessionUser.TenantId != 71 && SessionUser.TenantId != 16 && SessionUser.TenantId != 88 && SessionUser.TenantId != 115) {
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = item.long_name;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'route') {
              Street = item.long_name;
            }
            if (item.types[0] === 'subpremise') {
              DoorNr = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              City = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              District = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_4') {
              Neighborhood = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              No = item.long_name;
            }
          });
        }
        else if (SessionUser.TenantId == 16) // FOR UK MAPPING REQUEST CHANGED - GFSM-4860
        {
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = item.long_name;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'route') {
              Street = item.long_name;
            }
            if (item.types[0] === 'subpremise') {
              DoorNr = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              State = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              District = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_4') {
              Neighborhood = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              No = item.long_name;
            }
            if (item.types[0] === 'postal_town') {
              City = item.long_name;
            }

          });

        }
        else if (SessionUser.TenantId == 115) {
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = item.long_name;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'route') {
              Street = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              City = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              State = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              DoorNr = item.long_name;
            }
          });
          if (City == '' || City == null) {
            City = State
          }
        }
        else if (SessionUser.TenantId == 12 && SessionUser.TenantId == 53) {
          const streetComponents = {
            route: "",
            premise: "",
            street_number: "",
          };
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = item.long_name;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'postal_town') {
              District = item.long_name;
            }
            if (item.types[0] === 'route') {
              streetComponents.route = item.long_name;
            }
            if (item.types[0] === 'premise') {
              streetComponents.premise = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              streetComponents.street_number = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              City = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              Region = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              DoorNr = item.long_name;
            }
          });
          Street = `${streetComponents.route} ${streetComponents.premise}/${streetComponents.street_number}`.trim();
          if (City == '' || City == null) {
            City = State
          }
        }
        else if (SessionUser.TenantId == 88) {
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = item.long_name;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'route') {
              Street = item.long_name;
            }
            if (item.types[0] === 'locality') {
              City = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              Region = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              State = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              DoorNr = item.long_name;
            }
          });
          if (City == '' || City == null) {
            City = State
          }
        }
        else {
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = item.long_name;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'route') {
              Street = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              City = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              State = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              DoorNr = item.long_name;
            }
          });
        }
        var Data = [...formData.Addresses];
        var AddressItem = {
          ...Data[AddressIndex],
          AddressItem: formatted_address,
          Latitude: lat,
          Longitude: lng,
          PostCode: postal_code,
          Street: Street,
          Neighborhood: Neighborhood,
          District: District,
          City: City,
          Apartment: No,
          DoorNr: (SessionUser.TenantCode == "gb" && DoorNr?.length < 1) ? No : DoorNr,//Ask eren bout this "logic"..
          State: State,
          Region: Region
        };

        // formData.Addresses[AddressIndex]?.Region
        // formData.Addresses[AddressIndex]?.State
        Data[AddressIndex] = AddressItem;
        setFormdata({ ...formData, Addresses: Data });
        setLoading2(false);
        setGoogleAddressSearchPopup(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const min = 0;
  const max = 365;

  const SetCountryData = (event, data) => {
    setCountryDataControl(data);
  };


  const GetWorkCaseFeedback = item => {
    setOpenFeedbackPopup(false);
    setLoading2(true);
    axios.get(`/GetWorkCaseFeedbacks/${item.WorkCaseId}`)
      .then(response => {
        if (response.data.length > 0) {
          setFeedback(response.data);
          setOpenFeedbackPopup(false);
          setOpenFeedbackDetailPopup(true);
          setLoading2(false);
        }
        else {
          setOpenFeedbackDetailPopup(true);
          setLoading2(false);
        }
      })
      .catch(error => { });
    setLoading2(false);
  };

  const GetFeedbackDesc = (item) => {
    axios.get(`/GetFeedbackDesc/${item.WorkCaseId}`)
      .then(response => {
        if (response.data.length > 0) {
          setFeedbackList(response.data);
          setOpenFeedbackDetailPopup(true);
        }
        else {

        }
      })
      .catch(error => { });
  };



  const getNpsDetail = (Control, WorkOrderId, ServiceShopId) => {
    if (Control === 0) {
      return;
    }
    setInformationDetailPopup(true)
    setWorkOrderId(WorkOrderId)
    setInfoServiceShopId(ServiceShopId)
  }

  function closeInserAssetPopup() {
    setInsertAssetPopup(false)
    // setUyariTip('success');
    // setUyari(true);
  }

  function closeInserAssetDaysPopup() {
    setInsertAssetDaysPopup(false)
  }

  const setNewWorkCasePopupClose = () => {
    setNewWorkCasePopup(false);
  }

  const GetMaterialOrderFromConsumer = (consumerId) => {
    setConsumerMaterialOrders([]);
    axios
      .get(`/GetMaterialOrderFromConsumer/` + consumerId)
      .then(response => {

        if (response.data.length > 0) {
          setConsumerMaterialOrders(response.data);
          setOpenMaterialOrdersPopUp(true);
        } else {
          setConsumerMaterialOrders([]);
          setResponseType('error');
          setResponseDsc(t('lblNoMaterialOrders'));
          setOpenSnackbar(true);
        }
      })
      .catch(error => {
        setResponseType('error');
        setResponseDsc(t('lblError'));
        setOpenSnackbar(true);
      });
  }

  const GetMaterialOrderFromOrderId = (row) => {
    axios
      .get(`/GetMaterialOrderFromOrderId/` + row.OrderId)
      .then(response => {
        const Response = response.data[0];
        if (response.data.length > 0) {
          handleRoute(Response);
        } else {
          setResponseType('error');
          setResponseDsc(t('lblError'));
          setOpenSnackbar(true);
        }
      })
      .catch(error => {
        setResponseType('error');
        setResponseDsc(t('lblError'));
        setOpenSnackbar(true);
      });
  };

  function handleRoute(value) {
    if (history && history.push && typeof history.push === 'function') {
      if (value.ShipToToOtc != 0 && SessionUser.TenantId == 79) {
        history.push({ pathname: '/materialOrder2/Create/ForOTC', state: value });
      } else if (value.ShipToToServiceShopId != 0 || value.ShipToToRetailerId != 0) {
        history.push({ pathname: '/materialOrder2/Create/ForPartner', state: value });
      }
    } else {
      console.error('history.push is not available. Application might crash.');
    }
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const changeCustomerType = (CustomerTypeId) => {
    // GFSM-6288
    dispatch(customerThunks.GetCustomerTypeTaxNumberMatching(({
      customerTypeId: CustomerTypeId
    }))).then((res) => {
      if (res.payload != null && res.payload.TaxNumber != null) {
        setFormdata({
          ...formData,
          TaxId: res.payload.TaxNumber,
          CustomerTypeId: CustomerTypeId,
          ExceptId: "1"
        })
      }
      else {
        setFormdata({
          ...formData,
          CustomerTypeId: CustomerTypeId
        })
      }
    })
  }


  return (
    <>
      <Breadcrumbs aria-label="breadcrumb">
        <Link color="inherit">Sirius</Link>
        <Typography color="textPrimary">{t('lblWorkCase')}</Typography>
      </Breadcrumbs>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert
          onClose={uyariKapat}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          message={ResponseDsc}
          variant={ResponseType}
        />
      </Snackbar>
      <Backdrop className={classes.backdrop} open={isGetTaskRequestSending}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card className={clsx(classes.root, className)}>
        <BottomNavigation
          value={TopBarValue}
          className={classes.stickToBottom}
          onChange={(event, newValue) => {
            setTopBarValue(newValue);
            if (newValue === 0) {
              //KAYDET
              if (formData.ConsumerId === undefined) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblMustFieldControl')
                });
                setUyariTip('error');
                setUyari(true);
                setRequired(true);
                return;
              }
              SaveConsumer();
            }
            if (newValue === 1) {
              //Yeni Müşteri
              GetSecretNote(0);
              setFormdata({ ...DefaultConsumerValue, Phones: [] });
              setAddressIndex(0);
              setVulnerabilitiesId(0);
              setNewTel(countryCode);
              sessionStorage.removeItem('SearhResult');
              sessionStorage.removeItem('ConsumerId');
              setRequired(false);
            }
            if (newValue === 2) {
              //Müşteri Adresleri
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              if (formData.Addresses.filter(x => x.AddressId > 0).length > 0) {
                setAddressPopup(true);
              }
            }
            if (newValue === 3) {
              //Müşteri WorkCaseleri
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              sessionStorage.removeItem('ConsumerId');
              sessionStorage.setItem('ConsumerId', formData.ConsumerId);
              handleConsumerWorkCase(1);
              // handleRefresh();
            }
            if (newValue === 4) {
              //Yeni WorkCase
              setNewWorkCaseData(DefaultWorkCase);
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              var Data = { ...NewWorkCaseData };
              Data.ConsumerId = formData.ConsumerId;
              Data.ProductId = 0;
              Data.Product = '';
              Data.IssueId = 0;
              Data.Issue = '';
              Data.Retailer = '';
              Data.RetailerId = 0;
              Data.StatusId = 1;
              Data.WarrantyTypeId = 0;
              Data.Comment = '';
              GetConsumerAssetsData();
              setNewWorkCaseData(Data);
              setNewAssetChosen(false);
              setAssetChosen(false);
              setNewWorkCasePopup(true);
              setIssueTypeId(1)
            }
            if (newValue === 5) {
              //Assetler
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              GetConsumerAssets();
            }
            if (newValue === 6) {
              //Müşteriye ait dosyalar
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              GetConsumerFileData();
            }
            if (newValue === 7) {
              // GDPR
              GetGdpr();
            }
            if (newValue === 8) {
              // MaterialOrders
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              GetMaterialOrderFromConsumer(formData.ConsumerId);
            }
            if (newValue === 9) {
              // Tasks
              setJobSearchPopup(true);
            }
            //NPS Kaldırıldı Menu
            // if (newValue === 9) {
            //   if (
            //     formData.ConsumerId === 0 ||
            //     formData.ConsumerId === undefined
            //   ) {
            //     setresponseMessage({
            //       ErrorCode: 10,
            //       ErrorDescription: t('lblCustomerWarning')
            //     });
            //     setUyariTip('error');
            //     setUyari(true);
            //     return;
            //   }
            //   GetConsumerInformation();
            // }
          }}
          showLabels
        >
          <BottomNavigationAction label={t('lblSave')} icon={<SaveIcon />} />
          {SessionUser.TenantId !== 58 && (
            <BottomNavigationAction
              label={t('lblNewConsumer')}
              icon={<PersonAddIcon />}
            />
          )}
          <BottomNavigationAction
            label={
              t('lblAddress') +
              ' (' +
              parseInt(
                formData.Addresses?.filter(x => x.AddressId > 0).length
              ) +
              ')'
            }
            icon={<LocationOnIcon />}
          />
          <BottomNavigationAction
            label={
              t('lblWorkCase') +
              ' (' +
              (formData.WorkCaseCount ?? 0) +
              ')'
            }
            icon={<BusinessCenterIcon />}
          />
          {SessionUser.TenantId !== 58 && (
            <BottomNavigationAction
              label={t('lblNewWorkCase')}
              icon={<NextWeekIcon />}
            />
          )}
          <BottomNavigationAction
            label={t('lblAssets') + ' (' + parseInt(formData?.AssetCount) + ')'}
            icon={<VideogameAssetIcon />}
          />
          <BottomNavigationAction
            label={t('lblFiles')}
            icon={<AttachmentIcon />}
          />
          <BottomNavigationAction
            label={t('lblGdpr')}
            icon={<AssignmentTurnedInIcon />}
          />
          <BottomNavigationAction
            label={t('lblMaterialOrders')}
            icon={<ShoppingCartIcon />}
          />
          {SessionUser.ServiceShopTypeId !== 16 && SessionUser.ServiceShopTypeId !== 18 && (
            <BottomNavigationAction
              label={t('lblTasks')}
              icon={<AssignmentIcon />}
            />
          )}
          {/* NPS Kaldırıldı Menu */}
          {/* <BottomNavigationAction
            label={t('lblNPS')}
            icon={<ThumbsUpDownIcon />}
          /> */}
        </BottomNavigation>
      </Card>
      <Card>
        <CardHeader
          style={{ textAlign: 'left' }}
          title={formData.Search ? formData.Search : t('lblNewConsumer')}
        />
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} lg={6}>
              <Card className={classes.cards}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <CardHeader
                      style={{ textAlign: 'left' }}
                      title={t('lblPersonInfo')}
                      action={<Box p={2.5}></Box>}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={formData.VIP}
                          onChange={event =>
                            setFormdata({ ...formData, VIP: event.target.checked })
                          }
                          name="VIP"
                        />
                      }
                      label={t('VIP')}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <CardHeader
                      style={{ textAlign: 'right' }}
                      title={
                        formData.ConsumerId == 0
                          ? 'Id: ' + 0
                          : 'Id: ' + formData.ConsumerId
                      }
                      action={
                        <Box p={0}>
                          <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={handleClickScreen}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            id="long-menu"
                            anchorEl={anchorElScreen}
                            keepMounted
                            open={openScreen}
                            onClose={handleClose}
                          >
                            <FormControl component="fieldset">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={IdNrScreen}
                                      onChange={handleChangeScreen}
                                      name="IdNrScreen"
                                    />
                                  }
                                  label={t('lblIdNr')}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={TaxOfficeScreen}
                                      onChange={handleChangeScreen}
                                      name="TaxOfficeScreen"
                                    />
                                  }
                                  label={t('lblTaxOffice')}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={TaxIdScreen}
                                      onChange={handleChangeScreen}
                                      name="TaxIdScreen"
                                    />
                                  }
                                  label={t('lblTaxId')}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={ExceptIdScreen}
                                      onChange={handleChangeScreen}
                                      name="ExceptIdScreen"
                                    />
                                  }
                                  label={t('lblExceptId')}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={InsurancePlanNumberScreen}
                                      onChange={handleChangeScreen}
                                      name="InsurancePlanNumberScreen"
                                    />
                                  }
                                  label={t('lblInsurancePlanNumber')}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={ReferralNumberScreen}
                                      onChange={handleChangeScreen}
                                      name="ReferralNumberScreen"
                                    />
                                  }
                                  label={t('lblReferralNumber')}
                                />
                              </FormGroup>
                            </FormControl>
                          </Menu>
                        </Box>
                      }
                    />
                  </Grid>
                </Grid>
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        // error={formData?.Title?.length > 0 ? false : Required}
                        label={t('lblTitle')}
                        autoComplete="no"
                        value={formData?.Title ? formData?.Title : ''}
                        id="Title"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            Title: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        {consumerTitleData.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Dsc}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        id="CustomerTypeId"
                        label={t('lblCustomerType')}
                        autoComplete="no"
                        error={formData.CustomerTypeId > 0 ? false : Required}
                        value={
                          CustomerTypeData[0]
                            ? formData.CustomerTypeId
                              ? formData.CustomerTypeId
                              : CustomerTypeData[0]
                            : ''
                        }
                        onChange={event =>
                          changeCustomerType(event.target.value)
                        }
                        variant="outlined"
                      >
                        {CustomerTypeData.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="FirstName"
                        autoComplete="no"
                        value={formData.FirstName ? formData.FirstName : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            FirstName: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblFirstName')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="MiddleName"
                        value={formData.MiddleName ? formData.MiddleName : ''}
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            MiddleName: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblMiddleName')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        error={formData.LastName.length > 0 ? false : Required}
                        required
                        id="LastName"
                        value={formData.LastName ? formData.LastName : ''}
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            LastName: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblLastName')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <TextField
                        size="small"
                        id="IdNr"
                        style={{ display: IdNrScreen ? '' : 'none' }}
                        value={formData.IdNr ? formData.IdNr : ''}
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({ ...formData, IdNr: event.target.value })
                        }
                        fullWidth
                        label={t('lblIdNr')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="TaxOffice"
                        style={{ display: TaxOfficeScreen ? '' : 'none' }}
                        value={formData.TaxOffice ? formData.TaxOffice : ''}
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            TaxOffice: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblTaxOffice')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <TextField
                        size="small"
                        id="TaxId"
                        style={{ display: TaxIdScreen ? '' : 'none' }}
                        autoComplete="no"
                        value={formData.TaxId ? formData.TaxId : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            TaxId: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblTaxId')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2}>
                      <TextField
                        size="small"
                        id="ExceptId"
                        style={{ display: ExceptIdScreen ? '' : 'none' }}
                        autoComplete="no"
                        value={formData.ExceptId ? formData.ExceptId : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            ExceptId: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblExceptId')}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <TextField
                        size="small"
                        id="Email"
                        autoComplete="no"
                        value={formData.Email ? formData.Email : ''}
                        helperText={emailError}
                        error={ValidControlColor}
                        onChange={event => validateEmail(event)}
                        fullWidth
                        label={t('lblEmail')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="InsurancePlanNumber"
                        style={{
                          display: InsurancePlanNumberScreen ? '' : 'none'
                        }}
                        value={
                          formData.InsurancePlanNumber
                            ? formData.InsurancePlanNumber
                            : ''
                        }
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            InsurancePlanNumber: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblInsurancePlanNumber')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="ReferralNumber"
                        style={{ display: ReferralNumberScreen ? '' : 'none' }}
                        value={
                          formData.ReferralNumber ? formData.ReferralNumber : ''
                        }
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            ReferralNumber: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblReferralNumber')}
                        variant="outlined"
                      />
                    </Grid>
                    {/* Telefon Bölümü */}

                    <Grid item xs={12} sm={1} lg={1}>
                      <Box p={1}>
                        <AddBoxIcon onClick={handleOnAdd} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={3} lg={3}>
                      <TextField
                        size="small"
                        fullWidth
                        error={ParamPhonesType > 0 ? false : Required}
                        select
                        label={t('lblSelectType')}
                        id="ParamPhonesType"
                        value={
                          PhoneTypes[0]
                            ? ParamPhonesType
                              ? ParamPhonesType
                              : PhoneTypes[0]
                                ? PhoneTypes[0].Id
                                : 1
                            : 1
                        }
                        onChange={event =>
                          setParamPhonesType(event.target.value)
                        }
                        variant="outlined"
                      >
                        {PhoneTypes.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <PhoneInput
                        country={SessionUser.TenantCode}
                        enableSearch={true}
                        onFocus={SetCountryData}
                        name={'phone'}
                        ref={phoneRef}
                        inputProps={{
                          name: 'phone',
                          required: true
                        }}
                        inputStyle={
                          Required & (formData?.Phones?.length === 0)
                            ? { borderColor: '#e53935' }
                            : { width: '100' }
                        }
                        containerStyle={{ textAlign: 'left' }}
                        countryCodeEditable={false}
                        masks={{mt: '.... ....'}}
                        value={newtel}
                        onChange={handleOnChange}
                      />
                    </Grid>
                    <Grid container item xs={12} spacing={1}>
                      {formData?.Phones?.map((item, index) => (
                        <Grid container item xs={12} spacing={1} key={index}>
                          <Grid item xs={12} sm={1} lg={1}>
                            <Box p={1}>
                              <DeleteForeverOutlinedIcon
                                style={{ color: 'black' }}
                                onClick={event =>
                                  DeletePhoneItem(event, item.Phone)
                                }
                              />
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={3} lg={3}>
                            <TextField
                              size="small"
                              fullWidth
                              value={item.PhoneType}
                              disabled={true}
                              variant="outlined"
                            ></TextField>
                          </Grid>
                          <Grid item xs={12} sm={6} lg={6}>
                            <PhoneInput
                              value={item.Phone}
                              // country={SessionUser.TenantCode}
                              disabled={true}
                              inputStyle={{ width: '100%' }}
                              containerStyle={{ textAlign: 'left' }}
                              masks={{mt: '.... ....'}}
                            // onChange={phone => this.setState({ phone })}
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>

                    {/* Telefon Bölümü */}
                    <Grid item xs={12}>
                      <Typography variant="h5" >
                        {t('lblLastUpdate')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <Typography variant="body2"
                        color="textSecondary"
                        component="p" >
                        {t('lblCreateUser')}
                      </Typography>
                      <Typography variant="body1"
                        component="h1" gutterBottom> {(formData.CreateEmployee ? formData.CreateEmployee : '-')}
                      </Typography>
                      <Typography variant="body2"
                        color="textSecondary"
                        component="p">
                        {t('lblCreateDate')}
                      </Typography>
                      <Typography variant="body1"
                        component="h1" gutterBottom>
                        {formData.CreateDate ? moment(formData.CreateDate).format('DD/MM/YYYY HH:mm') : '-'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <Typography variant="body2"
                        color="textSecondary"
                        component="p">
                        {t('lblUpdateUser')}
                      </Typography>
                      <Typography variant="body1"
                        component="h1" gutterBottom>
                        {(formData.UpdateEmployee ? formData.UpdateEmployee : '-')}
                      </Typography>
                      <Typography variant="body2"
                        color="textSecondary"
                        component="p">
                        {t('lblUpdateDate')}
                      </Typography>
                      <Typography variant="body1"
                        component="h1" gutterBottom>
                        {formData.UpdateDate ? moment(formData.UpdateDate).format('DD/MM/YYYY HH:mm') : '-'}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>
              <Card className={classes.cards}>
                <CardHeader
                  style={{
                    textAlign: 'left',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }}
                  action={
                    <Grid container spacing={2}>
                      {SessionUser.TenantId !== 9 && (
                        <Grid
                          item
                          onClick={() => setGoogleAddressSearchPopup(true)}
                        >
                          <FormControlLabel
                            control={
                              <Box p={1}>
                                <FcGoogle color="primary"></FcGoogle>
                              </Box>
                            }
                            label={t('Google') + 'Map' + t('lblSearch')}
                            labelPlacement="end"
                          />
                        </Grid>
                      )}
                      <Grid item>
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <SearchIcon
                                color="primary"
                                onClick={() => setAddressSearchPopup(true)}
                              ></SearchIcon>
                            </Box>
                          }
                          label={t('lblSearch')}
                          labelPlacement="end"
                        />
                      </Grid>
                      <Grid item>
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <AddBoxIcon
                                color="primary"
                                onClick={handleOnAddressAdd}
                              />
                            </Box>
                          }
                          label={t('lblNew')}
                          labelPlacement="end"
                        />
                      </Grid>
                      <Grid item>
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={
                                formData.Addresses[AddressIndex]?.PrimaryAddress
                                  ? true
                                  : false
                              }
                              onChange={event =>
                                handleChangeAddressPrimary(event, AddressIndex)
                              }
                              name="PrimaryAddress"
                              id="PrimaryAddress"
                            />
                          }
                          labelPlacement="end"
                          label={consumerAddressPrimarySecondary}
                        />
                      </Grid>
                      <Grid item>
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <MoreVertIcon
                                color="primary"
                                onClick={handleClickAddressScreen}
                              />
                            </Box>
                          }
                          labelPlacement="start"
                        />
                        <Menu
                          id="long-menu"
                          anchorEl={anchorElAddressScreen}
                          keepMounted
                          open={openAddressScreen}
                          onClose={handleAddressClose}
                        >
                          <FormControl component="fieldset">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={StateScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="StateScreen"
                                  />
                                }
                                label={t('lblState')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={RegionScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="RegionScreen"
                                  />
                                }
                                label={t('lblRegion')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={ApartmentScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="ApartmentScreen"
                                  />
                                }
                                label={t('lblApartment')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={DoorNrScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="DoorNrScreen"
                                  />
                                }
                                label={t('lblDoorNr')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={PostCodeScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="PostCodeScreen"
                                  />
                                }
                                label={t('lblPostCode')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={LongitudeScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="LongitudeScreen"
                                  />
                                }
                                label={t('lblLongitude')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={LatitudeScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="LatitudeScreen"
                                  />
                                }
                                label={t('lblLatitude')}
                              />
                            </FormGroup>
                          </FormControl>
                        </Menu>
                      </Grid>
                    </Grid>
                  }
                  title={t('lblAddress')}
                />
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} lg={6}>
                      <ReactFlagsSelect
                        size="small"
                        selected={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.Country === ''
                              ? selected
                              : formData.Addresses[AddressIndex]?.Country
                            : selected
                        }
                        searchable
                        id="Country"
                        name="Country"
                        onSelect={code => SetCountry(code, AddressIndex)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        autoComplete="no"
                        id="AddressTypeId"
                        label={t('lblAddressType')}
                        value={
                          AddressTypes[0]
                            ? formData.Addresses[AddressIndex]?.AddressTypeId
                              ? formData.Addresses[AddressIndex]?.AddressTypeId
                              : 1
                            : 1
                        }
                        required={
                          NewAddressCheck() ? RequiredAddress : false
                        }
                        error={
                          NewAddressCheck()
                            ? formData.Addresses[AddressIndex]?.AddressTypeId
                              > 0
                              ? false
                              : RequiredAddress
                            : false
                        }
                        onChange={event =>
                          handleChangeAddressId(event, AddressIndex)
                        }
                        variant="outlined"
                      >
                        {AddressTypes.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="State"
                        style={{ display: StateScreen ? '' : 'none' }}
                        autoComplete="no"
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.State
                            : ''
                        }
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        fullWidth
                        label={t('lblState')}
                        variant="outlined"
                      />
                    </Grid>
                    {SessionUser.TenantId != 71 ?
                      <Grid item xs={12} sm={6} lg={6}>
                        <Autocomplete
                          size="small"
                          fullWidth
                          freeSolo
                          autoSelect
                          style={{ display: RegionScreen ? '' : 'none' }}
                          value={
                            formData.Addresses
                              ? formData.Addresses[AddressIndex]?.Region
                              : ''
                          }
                          options={RegionData}
                          onChange={(event, newValue) => {
                            GetCity(event, AddressIndex, newValue);
                          }}
                          renderInput={params => (
                            <TextField
                              {...params}
                              label={t('lblRegion')}
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid> : null}

                    <Grid item xs={12} sm={6} lg={6}>
                      <Autocomplete
                        size="small"
                        fullWidth
                        freeSolo
                        autoSelect
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.City
                            : ''
                        }
                        options={CityData}
                        onChange={(event, newValue) => {
                          GetDistrictRequest(event, AddressIndex, newValue);
                        }}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label={t('lblCity')}
                            variant="outlined"
                            required={
                              NewAddressCheck() ? RequiredAddress : false
                            }
                            error={
                              NewAddressCheck()
                                ? formData.Addresses[AddressIndex]?.City
                                  ?.length > 0
                                  ? false
                                  : RequiredAddress
                                : false
                            }
                          />
                        )}
                      />
                    </Grid>
                    {SessionUser.TenantId != 71 ?
                      <Grid item xs={12} sm={6} lg={6}>
                        <Autocomplete
                          size="small"
                          fullWidth
                          freeSolo
                          autoSelect
                          value={
                            formData.Addresses
                              ? formData.Addresses[AddressIndex]?.District
                              : ''
                          }
                          id="controllable-states-distict"
                          options={DistrictData}
                          getOptionLabel={option => option}
                          onChange={(event, newInputValue) => {
                            ChangeDistrict(event, AddressIndex, newInputValue);
                          }}
                          renderInput={params => (
                            <TextField
                              {...params}
                              label={t('lblDistrict')}
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid> : null}
                    {SessionUser.TenantId != 71 ?
                      <Grid item xs={12} sm={6} lg={6}>
                        <Autocomplete
                          size="small"
                          fullWidth
                          id="Neighborhood"
                          freeSolo
                          autoSelect
                          options={NeighborhoodData}
                          getOptionLabel={option => option}
                          onChange={(event, newInputValue) =>
                            ChangeNeighborhood(event, AddressIndex, newInputValue)
                          }
                          value={
                            formData.Addresses
                              ? formData.Addresses[AddressIndex]?.Neighborhood
                              : ''
                          }
                          renderInput={params => (
                            <TextField
                              {...params}
                              label={t('lblNeighborhood')}
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid> : null}

                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="Street"
                        autoComplete="no"
                        inputProps={{
                          maxLength: 40,
                        }}
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.Street
                            : ''
                        }
                        fullWidth
                        label={t('lblStreet')}
                        variant="outlined"
                      />
                    </Grid>
                    {SessionUser.TenantId != 71 ?
                      <Grid item xs={12} sm={6} lg={4}>
                        <TextField
                          size="small"
                          id="Apartment"
                          style={{ display: ApartmentScreen ? '' : 'none' }}
                          autoComplete="no"
                          onChange={event =>
                            handleChangeAddress(event, AddressIndex)
                          }
                          value={
                            formData.Addresses
                              ? formData.Addresses[AddressIndex]?.Apartment
                              : ''
                          }
                          fullWidth
                          label={t('lblApartment')}
                          variant="outlined"
                        />
                      </Grid> : null}
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="DoorNr"
                        style={{ display: DoorNrScreen ? '' : 'none' }}
                        autoComplete="no"
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.DoorNr
                            : ''
                        }
                        fullWidth
                        label={t('lblDoorNr')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Autocomplete
                        size="small"
                        fullWidth
                        id="PostCode"
                        style={{ display: PostCodeScreen ? '' : 'none' }}
                        freeSolo
                        autoSelect
                        options={PostCodeData}
                        onChange={(event, newInputValue) =>
                          ChangePostCode(event, AddressIndex, newInputValue)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.PostCode
                            : ''
                        }

                        getOptionLabel={option => option}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label={t('lblPostCode')}
                            variant="outlined"
                            required={
                              NewAddressCheck() ? RequiredAddress : false
                            }
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={12}>
                      <TextField
                        size="small"
                        multiline
                        rows={10}
                        fullWidth
                        id="AddressItem"
                        /* error={
                           NewAddressCheck()
                             ? formData.Addresses[AddressIndex]?.AddressItem
                               ?.length > 0
                               ? false
                               : RequiredAddress
                             : false
                         }*/
                        // required={NewAddressCheck() ? RequiredAddress : false}
                        autoComplete="no"
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.AddressItem
                            : ''
                        }
                        label={t('lblAddress')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="Longitude"
                        style={{ display: LongitudeScreen ? '' : 'none' }}
                        autoComplete="no"
                        disabled
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.Longitude
                            : ''
                        }
                        fullWidth
                        label={t('lblLongitude')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="Latitude"
                        style={{ display: LatitudeScreen ? '' : 'none' }}
                        autoComplete="no"
                        disabled
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.Latitude
                            : ''
                        }
                        fullWidth
                        label={t('lblLatitude')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={1} lg={1}>
                      <Box p={1}>
                        <LocationOnIcon
                          style={{
                            display: LatitudeScreen ? '' : 'none',
                            color: 'red'
                          }}
                          onClick={event =>
                            handleClickMap(
                              event,
                              formData.Addresses[AddressIndex]?.Latitude,
                              formData.Addresses[AddressIndex]?.Longitude
                            )
                          }
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

          </Grid>
        </CardContent>
        {["top"].map((anchor) => (
          <React.Fragment key={anchor}>
            <Zoom key="primary" in={true} unmountOnExit>
              <Fab className={classes.fabGreen}
                onClick={toggleDrawer(anchor, true)}
                color={"inherit"}>
                <UpIcon />
              </Fab>
            </Zoom>
            <SwipeableDrawer
              anchor={anchor}
              open={stateMobile[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
            >
              <div
                className={clsx(classes.list, {
                  [classes.fullList]: anchor === "top" || anchor === "bottom"
                })}
                style={{ height: "300px" }}
                role="presentation"
                onClick={toggleDrawer(anchor, false)}
                onKeyDown={toggleDrawer(anchor, false)}
              >
                <br />
                <br />
                <BottomNavigation
                  value={TopBarValue}
                  className={classes.stickToBottom}
                  onChange={(event, newValue) => {
                    setTopBarValue(newValue);
                    if (newValue === 0) {
                      //KAYDET
                      if (formData.ConsumerId === undefined) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblMustFieldControl')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        setRequired(true);
                        return;
                      }
                      SaveConsumer();
                    }
                    if (newValue === 1) {
                      //Yeni Müşteri
                      GetSecretNote(0);
                      setFormdata({ ...DefaultConsumerValue, Phones: [] });
                      setAddressIndex(0);
                      setVulnerabilitiesId(0);
                      setNewTel(countryCode);
                      sessionStorage.removeItem('SearhResult');
                      sessionStorage.removeItem('ConsumerId');
                      setRequired(false);
                    }
                    if (newValue === 2) {
                      //Müşteri Adresleri
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      if (formData.Addresses.filter(x => x.AddressId > 0).length > 0) {
                        setAddressPopup(true);
                      }
                    }
                    if (newValue === 3) {
                      //Müşteri WorkCaseleri
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      sessionStorage.removeItem('ConsumerId');
                      sessionStorage.setItem('ConsumerId', formData.ConsumerId);
                      handleConsumerWorkCase(1);
                      // handleRefresh();
                    }
                    if (newValue === 4) {
                      //Yeni WorkCase
                      setNewWorkCaseData(DefaultWorkCase);
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      var Data = { ...NewWorkCaseData };
                      Data.ConsumerId = formData.ConsumerId;
                      Data.ProductId = 0;
                      Data.Product = '';
                      Data.IssueId = 0;
                      Data.Issue = '';
                      Data.Retailer = '';
                      Data.RetailerId = 0;
                      Data.StatusId = 1;
                      Data.WarrantyTypeId = 0;
                      Data.Comment = '';
                      GetConsumerAssetsData();
                      setNewWorkCaseData(Data);
                      setNewAssetChosen(false);
                      setAssetChosen(false);
                      setNewWorkCasePopup(true);
                      setIssueTypeId(1)
                    }
                    if (newValue === 5) {
                      //Assetler
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetConsumerAssets();
                    }
                    if (newValue === 6) {
                      //Müşteriye ait dosyalar
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetConsumerFileData();
                    }
                    if (newValue === 7) {
                      // GDPR
                      GetGdpr();
                    }
                    if (newValue === 8) {
                      // Tasks
                      setJobSearchPopup(true);
                    }
                    //NPS Kaldırıldı Menu
                    // if (newValue === 9) {
                    //   if (
                    //     formData.ConsumerId === 0 ||
                    //     formData.ConsumerId === undefined
                    //   ) {
                    //     setresponseMessage({
                    //       ErrorCode: 10,
                    //       ErrorDescription: t('lblCustomerWarning')
                    //     });
                    //     setUyariTip('error');
                    //     setUyari(true);
                    //     return;
                    //   }
                    //   GetConsumerInformation();
                    // }
                  }}
                  showLabels
                >
                  <BottomNavigationAction label={t('lblSave')} icon={<SaveIcon />} />
                  {SessionUser.TenantId !== 58 && (
                    <BottomNavigationAction
                      label={t('lblNewConsumer')}
                      icon={<PersonAddIcon />}
                    />
                  )}
                  <BottomNavigationAction
                    style={{ display: 'none' }}
                    label={
                      t('lblAddress') +
                      ' (' +
                      parseInt(
                        formData.Addresses?.filter(x => x.AddressId > 0).length
                      ) +
                      ')'
                    }
                    icon={<LocationOnIcon />}
                  />
                  <BottomNavigationAction
                    label={
                      t('lblWorkCase') + ' (' + workCaseNumber + ')'
                    }
                    icon={<BusinessCenterIcon />}
                  />
                  {SessionUser.TenantId !== 58 && (
                    <BottomNavigationAction
                      label={t('lblNewWorkCase')}
                      icon={<NextWeekIcon />}
                    />
                  )}
                  <BottomNavigationAction
                    style={{ display: 'none' }}
                    label={t('lblAssets') + ' (' + parseInt(formData?.AssetCount) + ')'}
                    icon={<VideogameAssetIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblFiles')}
                    style={{ display: 'none' }}
                    icon={<AttachmentIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblGdpr')}
                    icon={<AssignmentTurnedInIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblMaterialOrders')}
                    style={{ display: 'none' }}
                    icon={<ShoppingCartIcon />}
                  />
                  {SessionUser.ServiceShopTypeId !== 16 && SessionUser.ServiceShopTypeId !== 18 && (
                    <BottomNavigationAction
                      label={t('lblTasks')}
                      style={{ display: 'none' }}
                      icon={<AssignmentIcon />}
                    />
                  )}
                </BottomNavigation>

                <br />
                <br />
                <Divider />
                <br />
                <br />
                <BottomNavigation
                  value={TopBarValue}
                  className={classes.stickToBottom}
                  onChange={(event, newValue) => {
                    setTopBarValue(newValue);
                    if (newValue === 0) {
                      //KAYDET
                      if (formData.ConsumerId === undefined) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblMustFieldControl')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        setRequired(true);
                        return;
                      }
                      SaveConsumer();
                    }
                    if (newValue === 1) {
                      //Yeni Müşteri
                      GetSecretNote(0);
                      setFormdata({ ...DefaultConsumerValue, Phones: [] });
                      setAddressIndex(0);
                      setVulnerabilitiesId(0);
                      setNewTel(countryCode);
                      sessionStorage.removeItem('SearhResult');
                      sessionStorage.removeItem('ConsumerId');
                      setRequired(false);
                    }
                    if (newValue === 2) {
                      //Müşteri Adresleri
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      if (formData.Addresses.filter(x => x.AddressId > 0).length > 0) {
                        setAddressPopup(true);
                      }
                    }
                    if (newValue === 3) {
                      //Müşteri WorkCaseleri
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      sessionStorage.removeItem('ConsumerId');
                      sessionStorage.setItem('ConsumerId', formData.ConsumerId);
                      handleConsumerWorkCase(1);
                      // handleRefresh();
                    }
                    if (newValue === 4) {
                      //Yeni WorkCase
                      setNewWorkCaseData(DefaultWorkCase);
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      var Data = { ...NewWorkCaseData };
                      Data.ConsumerId = formData.ConsumerId;
                      Data.ProductId = 0;
                      Data.Product = '';
                      Data.IssueId = 0;
                      Data.Issue = '';
                      Data.Retailer = '';
                      Data.RetailerId = 0;
                      Data.StatusId = 1;
                      Data.WarrantyTypeId = 0;
                      Data.Comment = '';
                      GetConsumerAssetsData();
                      setNewWorkCaseData(Data);
                      setNewAssetChosen(false);
                      setAssetChosen(false);
                      setNewWorkCasePopup(true);
                      setIssueTypeId(1)
                    }
                    if (newValue === 5) {
                      //Assetler
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetConsumerAssets();
                    }
                    if (newValue === 6) {
                      //Müşteriye ait dosyalar
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetConsumerFileData();
                    }
                    if (newValue === 7) {
                      // GDPR
                      GetGdpr();
                    }
                    if (newValue === 8) {
                      // Tasks
                      setJobSearchPopup(true);
                    }
                    //NPS Kaldırıldı Menu
                    // if (newValue === 9) {
                    //   if (
                    //     formData.ConsumerId === 0 ||
                    //     formData.ConsumerId === undefined
                    //   ) {
                    //     setresponseMessage({
                    //       ErrorCode: 10,
                    //       ErrorDescription: t('lblCustomerWarning')
                    //     });
                    //     setUyariTip('error');
                    //     setUyari(true);
                    //     return;
                    //   }
                    //   GetConsumerInformation();
                    // }
                  }}
                  showLabels
                >
                  <BottomNavigationAction label={t('lblSave')}
                    style={{ display: 'none' }}
                    icon={<SaveIcon />} />
                  {SessionUser.TenantId !== 58 && (
                    <BottomNavigationAction
                      label={t('lblNewConsumer')}
                      style={{ display: 'none' }}
                      icon={<PersonAddIcon />}
                    />
                  )}
                  <BottomNavigationAction
                    label={
                      t('lblAddress') +
                      ' (' +
                      parseInt(
                        formData.Addresses?.filter(x => x.AddressId > 0).length
                      ) +
                      ')'
                    }
                    icon={<LocationOnIcon />}
                  />
                  <BottomNavigationAction
                    style={{ display: 'none' }}
                    label={
                      t('lblWorkCase') + ' (' + workCaseNumber + ')'
                    }
                    icon={<BusinessCenterIcon />}
                  />
                  {SessionUser.TenantId !== 58 && (
                    <BottomNavigationAction
                      style={{ display: 'none' }}
                      label={t('lblNewWorkCase')}
                      icon={<NextWeekIcon />}
                    />
                  )}
                  <BottomNavigationAction

                    label={t('lblAssets') + ' (' + parseInt(formData?.AssetCount) + ')'}
                    icon={<VideogameAssetIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblFiles')}

                    icon={<AttachmentIcon />}
                  />
                  <BottomNavigationAction

                    style={{ display: 'none' }}
                    icon={<AssignmentTurnedInIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblMaterialOrders')}
                    style={{ display: 'none' }}
                    icon={<ShoppingCartIcon />}
                  />
                  {SessionUser.ServiceShopTypeId !== 16 && SessionUser.ServiceShopTypeId !== 18 && (
                    <BottomNavigationAction
                      label={t('lblTasks')}
                      style={{ display: 'none' }}
                      icon={<AssignmentIcon />}
                    />
                  )}
                </BottomNavigation>
              </div>
            </SwipeableDrawer>
          </React.Fragment>
        ))}
      </Card>
      <Dialog
        open={OpenMaterialOrder}
        fullWidth={true}
        maxWidth={'xl'}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          ?          <ForConsumer ConsumerPhone={formData && formData?.Phones?.length > 0 ? formData?.Phones[0].Phone : ''} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={ConsumerFilePopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setConsumerFilePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblFiles')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {Files.length !== 0 ? Files.map((item, index) => (
              <Grid item xs={12} key={index}>
                {item.Files.map((Fileitem, index) => (
                  <Card className={classes.cardsMax}>
                    <CardContent className={classes.cardsContentMax}>
                      <Typography gutterBottom variant="h6" component="h1">
                        {'Work Order Id : ' + item.WorkCaseId}{' '}
                        {'Work Case Id : ' + Fileitem.WorkOrderId}
                      </Typography>
                      <Typography>
                        <Chip
                          style={{
                            color: item.StatusId === 1 ? 'green' : 'red'
                          }}
                          icon={<BusinessCenterRoundedIcon />}
                          label={item.Status + ' ' + item.Issue}
                        />
                      </Typography>
                      <List className={classes.root}>
                        <ListItem
                          onClick={event =>
                            handleFileOpen(
                              event,
                              Fileitem.Id,
                              Fileitem.FileName
                            )
                          }
                        >
                          <ListItemAvatar>
                            <Avatar>
                              <ImageIcon />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              Fileitem.WorkOrderId + '-' + Fileitem.FileName
                            }
                            secondary={
                              Fileitem.FileDate + ' ' + Fileitem.FileType
                            }
                          />
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>
                ))
                }
              </Grid>
            ))
              :
              <Grid item xs={12} >
                <Typography gutterBottom variant="h6" component="h1" style={{ textAlign: 'center' }}>
                  {t('lblNoAttachment')}
                  <IconButton
                    edge="end"
                  >
                    <FreeBreakfastIcon />
                  </IconButton>
                </Typography>
              </Grid>
            }
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => setConsumerFilePopup(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={GdprPopup}
        fullWidth={false}
        maxWidth={'lg'}
        onClose={() => setGdprPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ textAlign: 'left' }}>
          {t('lblCommunicationPreferences')}
        </DialogTitle>

        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          {t('lblService')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card>
            <CardContent>
              <Grid item xs={12} container>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <SmsIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.Sms}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            Sms: event.target.checked
                          })
                        }
                        name="Sms"
                      />
                    }
                    label={t('lblSms')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <EmailIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.Email}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            Email: event.target.checked
                          })
                        }
                        name="Email"
                      />
                    }
                    label={t('lblEmail')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <PhoneIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.Phone}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            Phone: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPhone')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <InstagramIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.SocialMedia}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            SocialMedia: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblSocialMedia')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <WhatsAppIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.Whatsapp}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            Whatsapp: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblWhatsApp')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    < AllInboxIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.Message}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            Message: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPost')}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>


        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          {t('lblMarketing')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card>
            <CardContent>
              <Grid item xs={12} container>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <SmsIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        name="Sms"
                        checked={GdprData.MarketingSms}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingSms: event.target.checked
                          })
                        }
                      />
                    }
                    label={t('lblSms')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <EmailIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        name="Email"
                        checked={GdprData.MarketingEmail}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingEmail: event.target.checked
                          })
                        }
                      />
                    }
                    label={t('lblEmail')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <PhoneIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.MarketingPhone}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingPhone: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPhone')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <InstagramIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.MarketingSocialMedia}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingSocialMedia: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblSocialMedia')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <WhatsAppIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.MarketingWhatsapp}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingWhatsapp: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblWhatsApp')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <AllInboxIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.MarketingMessage}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingMessage: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPost')}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>


        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          {t('lblPartyMarketing')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card>
            <CardContent>
              <Grid item xs={12} container>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <SmsIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.ThirdSms}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdSms: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblSms')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <EmailIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.ThirdEmail}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdEmail: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblEmail')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <PhoneIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.ThirdPhone}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdPhone: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPhone')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <InstagramIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.ThirdSocialMedia}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdSocialMedia: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblSocialMedia')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <WhatsAppIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.ThirdWhatsapp}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdWhatsapp: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblWhatsApp')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <AllInboxIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary" checked={GdprData.ThirdMessage}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdMessage: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPost')}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>

        <Dialog
          open={AnonymyzePopup}
          fullWidth={false}
          maxWidth={'lg'}
          onClose={() => setAnonymyzePopup(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ fontWeight: 'bold', fontSize: 'large' }}>
            {t('lblAttention')}
          </DialogTitle>
          <Container maxWidth="xl" spacing={1} style={{ fontWeight: 'bold', fontSize: 'large' }}>
            <Divider />
            {t('lblAnonymyze')}
          </Container>
          <DialogActions>

            <IconButton
              color="primary"
              aria-label="save"
              onClick={() => CustomerAnonymyze()}
              component="span"
            >
              <ThumbUpIcon />
            </IconButton>

            <IconButton
              color="primary"
              onClick={() => setAnonymyzePopup(false)}
              aria-label="upload picture"
              component="span"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </Dialog>


        <DialogActions>
          <IconButton
            color="primary"
            aria-label="save"
            onClick={() => setAnonymyzePopup(true)}
            component="span"
          >
            <DeleteForeverIcon />
          </IconButton>

          <IconButton
            color="primary"
            aria-label="save"
            onClick={() => SaveGdpr()}
            component="span"
          >
            <SaveOutlinedIcon />
          </IconButton>

          <IconButton
            color="primary"
            onClick={() => setGdprPopup(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={jobSearchPopup}
        fullWidth={true}
        maxWidth={'xl'}
        scroll={scroll}
        onClose={() => setJobSearchPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t('lblTaskManagement')}
        </DialogTitle>
        <DialogContent dividers={scroll === 'paper'} style={{ minHeight: 150 }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={3} lg={3}>
              <Autocomplete
                size="small"
                fullWidth
                autoSelect
                disableClearable
                disabled={DisabledControl}
                value={ServiceShopData.find(x => x.ServiceShopId === tasksFilterModel.serviceShopId)}
                options={ServiceShopData || []}
                getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                getOptionSelected={(option, value) => option.ServiceShopId == value}
                renderInput={(params) => <TextField {...params} label={t('lblServiceShop')} variant="outlined"
                />}
                defaultValue={ServiceShopData.find(x => x.ServiceShopId === tasksFilterModel.serviceShopId)}
                onChange={(event, value) => {
                  let e = {
                    target: {
                      name: 'serviceShopId',
                      value: value?.ServiceShopId
                    }
                  };

                  handleTasksInputChange(e);

                }}
              />

            </Grid>
            <Grid item xs={12} sm={3} lg={3}>
              <Autocomplete
                size='small'
                fullWidth
                multiple
                options={StatusData || []}
                disableCloseOnSelect
                id="StatusId"
                value={tasksFilterModel?.statusId || []}
                getOptionLabel={(option) => option.FieldText}
                onChange={(event, val) => {
                  setSelectedValues(val);

                  let e = {
                    target: {
                      name: 'statusId',
                      value: val
                    }
                  }

                  handleTasksInputChange(e);
                }}
                disabled={tasksFilterModel.openCase}
                renderOption={(option, { selected }) => (
                  <li value={option.StatusId}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.FieldText}
                  </li>
                )}
                renderInput={(params) => <TextField {...params} label={t('lblStatus')} variant='outlined' />}
              />
            </Grid>
            <Grid item xs={12} sm={3} lg={3}>
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  locale={localeMap[locale]}
                >
                  <KeyboardDatePicker
                    color="primary"
                    disabled={tasksFilterModel.openCase}
                    inputVariant="outlined"
                    id="StartDateSearch"
                    size="small"
                    invalidDateMessage={t('hatali_tarih')}
                    maxDateMessage={t('maxDateMessage')}
                    minDateMessage={t('minDateMessage')}
                    format='dd.MM.yyyy'
                    fullWidth
                    variant="outlined"
                    value={tasksFilterModel?.startDate}
                    onChange={e => {
                      handleChangeStartDateSearch(e);

                      let event = {
                        target: {
                          name: 'startDate',
                          value: e
                        }
                      };

                      handleTasksInputChange(event);
                    }}
                    maxDate={EndDateSearch}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </Grid>
            <Grid item xs={12} sm={3} lg={3}>
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  locale={localeMap[locale]}
                >
                  <KeyboardDatePicker
                    color="primary"
                    size="small"
                    disabled={tasksFilterModel.openCase}
                    inputVariant="outlined"
                    id="EndDateSearch"
                    invalidDateMessage={t('hatali_tarih')}
                    maxDateMessage={t('maxDateMessage')}
                    minDateMessage={t('minDateMessage')}
                    format='dd.MM.yyyy'
                    fullWidth
                    variant="outlined"
                    value={tasksFilterModel?.endDate}
                    onChange={e => {
                      handleChangeEndDateSearch(e);

                      let event = {
                        target: {
                          name: 'endDate',
                          value: e
                        }
                      };

                      handleTasksInputChange(event);
                    }}
                    minDate={StartDateSearch}
                    maxDate={new Date(new Date(StartDateSearch).getTime() + 90 * 24 * 60 * 60 * 1000)} // max 90 days
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </Grid>
            <Grid item xs={12} sm={2} lg={1} xl={2} align="center">
              <FormControlLabel
                control={
                  <Switch
                    color="primary"
                    checked={tasksFilterModel?.openCase}
                    onChange={event => {
                      if (event.target.checked) {
                        let statuModel = [{ StatusId: 0, FieldText: t('lblAllStatus') }];
                        setSelectedValues(statuModel)

                        let eventForStatu = {
                          target: {
                            name: 'statusId',
                            value: statuModel
                          }
                        }

                        handleTasksInputChange(eventForStatu);
                      }
                      else {
                        setSelectedValues([])
                      }

                      let eventForOpenCase = {
                        target: {
                          name: 'openCase',
                          value: event.target.checked
                        }
                      };

                      handleTasksInputChange(eventForOpenCase);
                    }}
                    name="OpenCase"
                  />
                }
                label={t('lblOpenCase')}
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={1}>
              <TextField
                size="small"
                fullWidth
                type="number"
                label={t('lblOpenDay')}
                autoComplete="no"
                disabled={tasksFilterModel.openCase ? false : true}
                value={tasksFilterModel?.openDay}
                inputProps={{ minlength: min, maxLength: max }}
                id="OpenDay"
                onChange={event => {
                  setTaskOpenDay(event.target.value);

                  let e = {
                    target: {
                      name: 'openDay',
                      value: event.target.value
                    }
                  };

                  handleTasksInputChange(e);
                }}
                variant="outlined"
              ></TextField>
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <Button
                variant="contained"
                size="small"
                color="primary"
                fullWidth
                onClick={GetTasksData}
                disabled={isTaskCooldownActive}
                endIcon={<SearchIcon />}
              >
                {isTaskCooldownActive ? t('lblCooldownButton', { seconds: taskRemainingSeconds }) : t('search')}
              </Button>
              {isTaskCooldownActive && (
                <Typography variant="caption" color="textSecondary" align="center" display="block" style={{ marginTop: 4 }}>
                  {t('lblCooldownWait', { seconds: taskRemainingSeconds })}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <OmniExcelReport JsonData={TasksScreenData} ButtonType={4} />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <OmniExcelReport JsonData={detailedExcelData} ButtonType={3} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogContent dividers={scroll === 'paper'} style={{ minHeight: 500 }}>
          <DataGrid
            rows={TasksScreenData}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            loading={isGetTaskRequestSending}
            density={'compact'}
            filter={true}
            onSelectionChange={newSelection => {
              SetWorkOrderTaskDetail(newSelection);
            }}

          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setJobSearchPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={NewWorkCasePopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setNewWorkCasePopupClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblNewWorkCase')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} lg={6}>
              <Card className={classes.root}>
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblStatus')}
                        id="StatusId"
                        value={NewWorkCaseData ? NewWorkCaseData.StatusId : 1}
                        onChange={event =>
                          setNewWorkCaseData({
                            ...NewWorkCaseData,
                            StatusId: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        <MenuItem key={1} value={1}>
                          {t('lblNotAssigned')}
                        </MenuItem>
                        {/* <MenuItem key={2} value={2}>
                          {t('lblClose')}
                        </MenuItem> */}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <Autocomplete
                        id="ProductId"
                        options={Assets}
                        size="small"
                        autoSelect
                        getOptionLabel={p =>
                          p.ProductId
                            ? p.ProductCode +
                            '-' +
                            p.Product +
                            '-' +
                            p.ProductionYear +
                            '-' +
                            p.ProductionMonth +
                            '-' +
                            p.SerialNr +
                            '-' +
                            p.Warranty +
                            '-' +
                            p.WarrantyDate +
                            '-' +
                            p.Brand
                            : ''
                        }
                        getOptionSelected={(option, value) => option === value}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label={t('lblAsset')}
                            variant="outlined"
                            error={
                              NewWorkCaseData?.ProductId > 0
                                ? false
                                : RequiredWorkCase
                            }
                            required
                          />
                        )}
                        onChange={(event, value) => {
                          setNewWorkCaseAssets(value);
                        }}
                        disabled={newAssetChosen}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <ProductWorkCaseSearch
                        setProduct={setProduct}
                        value={
                          {
                            Dsc: NewWorkCaseData.Product || '',
                            Id: NewWorkCaseData.ProductId || 0
                          } || ''
                        }
                        error={
                          NewWorkCaseData?.ProductId > 0
                            ? false
                            : RequiredWorkCase
                        }
                        disabled={assetChosen}
                        searchParam={search}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <AppReasonSearch
                        setIssue={setIssue}
                        value={
                          {
                            Dsc: NewWorkCaseData.Issue || '',
                            Id: NewWorkCaseData.IssueId || 0
                          } || ''
                        }
                        searchParam={search}
                        error={
                          NewWorkCaseData?.IssueId > 0
                            ? false
                            : RequiredWorkCase
                        }
                        modelCode={modelCode}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>
              <Card className={classes.root}>
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={6} sm={6} lg={6}>
                      <RetailerSearch
                        setRetailer={setRetailer}
                        value={
                          {
                            Dsc: NewWorkCaseData.Retailer || '',
                            Id: NewWorkCaseData.RetailerId || 0
                          } || ''
                        }
                        searchParam={search}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6}>
                      <DistributorSearch
                        setDistributor={setDistributor}
                        value={
                          {
                            Dsc: NewWorkCaseData.Distributor || '',
                            Id: NewWorkCaseData.DistributorId || 0
                          } || ''
                        }
                        searchParam={search}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        id="OnSiteOperation"
                        label={t('lblOnSiteOperation')}
                        value={
                          NewWorkCaseData ? NewWorkCaseData.OnSiteOperation : ''
                        }
                        onChange={event =>
                          setNewWorkCaseData({
                            ...NewWorkCaseData,
                            OnSiteOperation: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        {PlaceData.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm={4} lg={4}>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={NewWorkCaseData.PotentialLiabiltiy === 1 || 0}
                            onChange={handlePotentialLiabiltiy}
                            name="UrgentCustomer"
                          />
                        }
                        label={t('lblPotential')}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        id="WarrantyTypeId"
                        required
                        label={t('lblWarranty')}
                        error={
                          NewWorkCaseData?.WarrantyTypeId > 0
                            ? false
                            : RequiredWorkCase
                        }
                        value={
                          NewWorkCaseData.WarrantyTypeId
                        }
                        onChange={event => {
                          handleChangeWarrantyTypeId(event);
                        }}
                        variant="outlined"
                      >
                        {WarrantyData.map(p => {
                          return (
                            <MenuItem key={p.WarrantyId} value={p.WarrantyId}>
                              {p.FieldText}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        label={t('lblSerialNumber')}
                        id="SerialNr"
                        value={NewWorkCaseData.SerialNr ? NewWorkCaseData.SerialNr : ''}
                        onChange={event =>
                          setNewWorkCaseData({
                            ...NewWorkCaseData,
                            SerialNr: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider
                          utils={DateFnsUtils}
                          locale={localeMap[locale]}
                        >
                          <KeyboardDatePicker
                            color="primary"
                            fullWidth
                            disableFuture={true}
                            size="small"
                            disabled={warrantyDateDisable || assetChosen}
                            inputVariant="outlined"
                            id="WarrantyDate"
                            label={t('lblWarrantyDate')}
                            invalidDateMessage={t('hatali_tarih')}
                            maxDateMessage={t('maxDateMessage')}
                            minDateMessage={t('minDateMessage')}
                            format={'dd.MM.yyyy'}
                            variant="outlined"
                            value={
                              NewWorkCaseData
                                ? NewWorkCaseData.WarrantyDate
                                : ''
                            }
                            onChange={e => SetWarrantyDate(e)}
                            KeyboardButtonProps={{
                              'aria-label': 'change date'
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider
                          utils={DateFnsUtils}
                          locale={localeMap[locale]}
                        >
                          <KeyboardDateTimePicker
                            color="primary"
                            fullWidth
                            size="small"
                            ampm={false}
                            disablePast
                            inputVariant="outlined"
                            id="WarrantyDate"
                            label={t('lblPrefferedDate')}
                            invalidDateMessage={t('hatali_tarih')}
                            maxDateMessage={t('maxDateMessage')}
                            minDateMessage={t('minDateMessage')}
                            format={'dd.MM.yyyy HH.mm'}
                            variant="outlined"
                            value={
                              NewWorkCaseData
                                ? NewWorkCaseData.AppointmentDate
                                : ''
                            }
                            onChange={e => setAppointmentData(e)}
                            KeyboardButtonProps={{
                              'aria-label': 'change date'
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                size="small"
                label={t('lblNote') + ' *'}
                name="Comment"
                multiline
                rows={6}
                fullWidth
                error={
                  NewWorkCaseData?.Comment !== ''
                    ? false
                    : RequiredWorkCaseComment
                }
                value={NewWorkCaseData.Comment ? NewWorkCaseData.Comment : ''}
                onChange={event =>
                  setNewWorkCaseData({
                    ...NewWorkCaseData,
                    Comment: event.target.value
                  })
                }
                variant="outlined"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => SaveWorkCase()}
            disabled={isButtonDisabled}
            aria-label="save"
            component="span"
          >
            <SaveOutlinedIcon />
          </IconButton>
          <IconButton
            color="primary"
            onClick={() => setNewWorkCasePopupClose()}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={AssetPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setAssetPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblAssets')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {Assets.map((row, index) => (
              <Grid item xs={12} sm={4} lg={4} key={index}>
                <Card className={classes.cardsAssetMax}>
                  <CardContent>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <img
                        alt="ProductGroup"
                        src={'/images/' + row.MainHierarchyId + '.png'}
                      />
                    </Box>
                  </CardContent>
                  <CardContent>
                    <DisplayField
                      label={t('lblProduct')}
                      value={
                        row.ProductCode + ' ' + row.Product + ' ' + row.Brand
                      }
                    />
                    <DisplayField
                      label={
                        t('lblProductionYear') +
                        '-' +
                        t('lblProductionMonth') +
                        '-' +
                        t('lblSerialNr')
                      }
                      value={
                        row.ProductionYear +
                        '-' +
                        row.ProductionMonth +
                        '-' +
                        row.SerialNr
                      }
                    />
                    <DisplayField
                      label={t('lblWarrany')}
                      value={row.Warranty + ' ' + row.WarrantyDate}
                    />
                    <DisplayField
                      label={t('lblRetailer')}
                      value={row.Dealer}
                    />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAssetPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={WorkCasePopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setWorkCasePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblWorkCase')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} lg={12}>
              <SearchBar
                value={searched}
                onChange={searchVal => requestSearch(searchVal)}
                onCancelSearch={() => cancelSearch()}
                style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
              />
            </Grid>
            {WorkCaseData.map((item, index) => (
              <Grid item xs={12} sm={3} lg={3} key={index}>
                <Card className={classes.cardsMax}>
                  <CardActionArea onClick={() => GetWorkCaseDetailOrder(item)}>
                    <CardContent className={classes.cardsContentMax}>
                      <Typography gutterBottom variant="h6" component="h1">
                        {item.WorkCaseId} -{' '}
                        <Chip
                          style={{
                            color: (item.StatusId === 1 ? 'orange' : (item.StatusId === 2 ? 'black' : (item.StatusId === 3 ? 'green' : (item.StatusId === 4 ? 'red' : 'purple'))))
                          }}
                          icon={<BusinessCenterRoundedIcon />}
                          label={
                            item.Status + ' (' + item?.WorkOrders?.length + ')'
                          }
                        />
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        {item.CallDate === undefined
                          ? ''
                          : Moment(item.CallDate).format('DD/MM/YYYY HH:mm') +
                          ' ' +
                          item.WarrantyType}
                        <br />
                        {item.Issue}
                        <br />
                        {item.ProductCode + ' ' + item.Product}
                        <br />
                        {item.Barcode ? t('Barcode') + ' : ' + item.Barcode : t('Barcode') + ' : '}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button
                      size="small"
                      onClick={() => GetWorkCaseDetailOrder(item)}
                    >
                      {t('lblDetail')}
                    </Button>
                  </CardActions>
                  <br />
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setWorkCasePopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={WorkOrderPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setWorkOrderPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblWorkOrder')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {WorkOrderData.length !== 0 ? WorkOrderData.map((item, index) => (
              <Grid item xs={12} sm={3} lg={3} key={index}>
                <Card className={classes.cardsMax}>
                  <CardActionArea
                    onClick={event => SetWorkOrderDetail(event, item)}
                  >
                    <CardContent className={classes.cardsContentMax}>
                      <Typography gutterBottom variant="h6" component="h1">
                        {item.WorkOrderId} -{' '}
                        <Chip
                          style={{
                            color: (item.StatusColor === 1 ? 'orange' :
                              (item.StatusColor === 2 ? 'black' :
                                (item.StatusColor === 3 || item.StatusColor === 5 ? 'green' :
                                  (item.StatusColor === 4 ? 'red' :
                                    'purple'))))
                          }}
                          icon={<NextWeekRoundedIcon />}
                          label={item.WorkOrderStatus}
                        />
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        {item.WarrantyType}
                        <br />
                        {item.WorkOrderIssue}
                        <br />
                        {item.OpenDate === undefined
                          ? ''
                          : `${t('lblOpenDate')}: ${Moment(item.OpenDate).format('DD/MM/YYYY HH:mm')}`}
                        <br />
                        {`${t('lblServiceShop')}: ${item.ServiceShop}`}
                        <br />
                        {`${t('lblEmployee')}: ${item.Employee}`}
                        <br />
                        {item.AppointmentDate === undefined
                          ? ''
                          : `${t('lblAppointmentDate')}: ${Moment(item.AppointmentDate).format('DD/MM/YYYY HH:mm')} - ${Moment(item.AppointmentEndDate).format('HH:mm')}`}
                        <br />
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button
                      size="small"
                      onClick={event => SetWorkOrderDetail(event, item)}
                    >
                      {t('lblDetail')}
                    </Button>
                  </CardActions>
                  <br />
                </Card>
              </Grid>
            ))
              : <Typography variant="h6" component="h2" gutterBottom>{t('lblDiffrentServiceWorkOrder')}</Typography>
            }
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setWorkCasePopup(true);
              setWorkOrderPopup(false);
            }}
            color="primary"
          >
            {t('lblBack')}
          </Button>
          <Button onClick={() => setWorkOrderPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={AddressPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setAddressPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblAddress')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {formData.Addresses.map((row, index) => (
              <Grid item xs={12} sm={4} lg={4} key={index}>
                <Card className={classes.cardArddress}>
                  <CardHeader
                    action={
                      <div>
                        <IconButton aria-label="settings">
                          <MoreVertIcon
                            onClick={event =>
                              setAddressPopupEdit(event, row, index)
                            }
                          />
                        </IconButton>
                        <IconButton aria-label="delete">
                          <DeleteForeverOutlinedIcon
                            style={{ color: 'red' }}
                            onClick={event => DeleteAddress(row.AddressId)}
                          ></DeleteForeverOutlinedIcon>
                        </IconButton>
                      </div>
                    }
                    title={row.AddressType}
                    subheader={getAddressHeader(row)}
                  />
                  <CardContent>
                    <Typography variant="caption" gutterBottom={true}>
                      {SessionUser.TenantId != 71 ? t('lblAddress') + "/" + t('lblStreet') + "/" + t('lblApartment') + "/" + t('lblDoorNr') : t('lblAddress') + "/" + t('lblStreet') + "/" + t('lblDoorNr')}
                    </Typography>
                    <Typography variant="h6">
                      {row.AddressItem +
                        ' ' +
                        row.Street +
                        ' ' +
                        row.Apartment +
                        ' ' +
                        row.DoorNr}
                    </Typography>
                    <Typography variant="caption" gutterBottom={true}>
                      {SessionUser.TenantId != 71 ? t('lblDistrict') + "/" + t('lblNeighborhood') : null}
                    </Typography>
                    <Typography variant="h6">
                      {row.District + ' ' + row.Neighborhood}
                    </Typography>
                    <Typography variant="caption" gutterBottom={true}>
                      {SessionUser.TenantId != 71 ? t('lblRegion') + "/" + t('lblCity') : t('lblCity')}
                    </Typography>
                    <Typography variant="h6">
                      {row.Region + ' ' + row.City}
                    </Typography>
                    <Typography variant="caption" gutterBottom={true}>
                      {t('lblPostCode')}
                    </Typography>
                    <Typography variant="h6">
                      {row.PostCode}
                    </Typography>
                    <Typography variant="caption" gutterBottom={true}>
                      {t('lblState') + "/" + t('lblCountry')}
                    </Typography>
                    <Typography variant="h6">
                      {row.State + ' ' + row.Country}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddressPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{ConfirmTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {ConfirmDescription}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary">{t('Evet')}</Button>
          <Button onClick={() => setOpen(false)} color="primary">
            {t('Hayir')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openChooseDate}
        onClose={() => setopenChooseDate(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{ConfirmTitle}</DialogTitle>
        <Divider />
        <DialogContent>
          <Typography variant="h6" component="h2" gutterBottom>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap[locale]}
              >
                <KeyboardDatePicker
                  margin="normal"
                  color="primary"
                  inputVariant="outlined"
                  id="BaslangiçTarihi"
                  label={t('BaslangicTarihi')}
                  invalidDateMessage={t('hatali_tarih')}
                  maxDateMessage={t('maxDateMessage')}
                  minDateMessage={t('minDateMessage')}
                  format={'dd.MM.yyyy'}
                  variant="outlined"
                  value={StartDate}
                  onChange={e => StartDatehandleChange(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Typography>
          <Typography variant="h6" component="h2" gutterBottom>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap[locale]}
              >
                <KeyboardDatePicker
                  margin="normal"
                  color="primary"
                  inputVariant="outlined"
                  id="BitisTarihi"
                  label={t('BitisTarihi')}
                  invalidDateMessage={t('hatali_tarih')}
                  maxDateMessage={t('maxDateMessage')}
                  minDateMessage={t('minDateMessage')}
                  format={'dd.MM.yyyy'}
                  variant="outlined"
                  value={EndDate}
                  onChange={e => EndDatehandleChange(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={e => handleRefreshDate(e)} color="primary">
            {t('Ok')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={GoogleAddressSearchPopup}
        onClose={() => setGoogleAddressSearchPopup(false)}
        fullWidth={true}
        maxWidth={'lg'}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t('lblGoogleMapAddressSearch')}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={10} sm={10} lg={10}>
              <TextField
                size="small"
                id="GoogleSearch"
                autoComplete="no"
                value={addressGoogleSearch}
                onChange={event => setaddressGoogleSearch(event.target.value)}
                fullWidth
                label={t('lblAddress')}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={2} sm={2} lg={2}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => SearchGoogleAddress()}
                endIcon={<FcGoogle />}
              >
                {t('Google') + ' ' + t('search')}
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogContent dividers={scroll === 'paper'}>
          <Backdrop className={classes.backdrop} open={loading || loading2}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <TableContainer style={{ maxHeight: 600, minHeight: 600 }}>
            <Table size="small" stickyHeader aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">{t('lblAdd')}</TableCell>
                  <TableCell align="left">{t('lblAddress')}</TableCell>
                  <TableCell align="left">{t('lblLatitude')}</TableCell>
                  <TableCell align="left">{t('lblLongitude')}</TableCell>
                  <TableCell align="left">{t('lblFind')}</TableCell>
                  <TableCell align="left">{t('lblType')}</TableCell>
                  <TableCell align="left">{t('lblIcon')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {GoogleAddressSearchResult?.results?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">
                      <IconButton
                        onClick={() =>
                          AddAddress(
                            item.formatted_address,
                            item?.geometry?.location?.lat,
                            item?.geometry?.location?.lng,
                            item.place_id
                          )
                        }
                      >
                        <AddBoxIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell align="left">{item.formatted_address}</TableCell>
                    <TableCell align="left">
                      {item?.geometry?.location?.lat}
                    </TableCell>
                    <TableCell align="left">
                      {item?.geometry?.location?.lng}
                    </TableCell>
                    <TableCell align="left">
                      <IconButton
                        onClick={event =>
                          handleClickMap(
                            event,
                            item?.geometry?.location?.lat,
                            item?.geometry?.location?.lng
                          )
                        }
                      >
                        <LocationOnIcon style={{ color: 'red' }} />
                      </IconButton>
                    </TableCell>
                    <TableCell align="left">
                      {item?.types?.map((itemType, index) => (
                        <Chip
                          key={index}
                          icon={<MdPlace />}
                          label={itemType}
                          clickable
                          color="primary"
                          variant="outlined"
                        />
                      ))}
                    </TableCell>
                    <TableCell align="left">
                      <img
                        src={item.icon}
                        style={{ width: 22, height: 22 }}
                        name={item.name}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setGoogleAddressSearchPopup(false)}
            color="primary"
          >
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={addressSearchPopup}
        onClose={() => setAddressSearchPopup(false)}
        maxWidth={'xl'}
        scroll={scroll}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Address Search</DialogTitle>
        <Divider />
        <DialogContent dividers={scroll === 'paper'}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={1} lg={1}></Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <TextField
                size="small"
                id="Region"
                autoComplete="no"
                value={addressSearch.Region}
                onChange={event => handleChangeAddressSearch(event)}
                fullWidth
                label={t('lblRegion')}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <TextField
                size="small"
                id="City"
                autoComplete="no"
                value={addressSearch.City}
                onChange={event => handleChangeAddressSearch(event)}
                fullWidth
                label={t('lblCity')}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <TextField
                size="small"
                id="District"
                autoComplete="no"
                value={addressSearch.District}
                onChange={event => handleChangeAddressSearch(event)}
                fullWidth
                label={t('lblDistrict')}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <TextField
                size="small"
                id="PostCode"
                autoComplete="no"
                value={addressSearch.PostCode}
                onChange={event => handleChangeAddressSearch(event)}
                fullWidth
                label={t('lblPostCode')}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={SearchAddress}
                endIcon={<SearchIcon />}
              >
                {t('search')}
              </Button>
            </Grid>
            <Grid item xs={12} sm={1} lg={1}></Grid>
          </Grid>
        </DialogContent>
        <DialogContent dividers={scroll === 'paper'} style={{ minHeight: 500 }}>
          <DataGrid
            rows={addressSearchResult}
            columns={addressSearchResultColumns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            loading={loading2}
            density={'compact'}
            filter={true}
            onSelectionChange={newSelection => {
              SetAdressWithSearchedResult(newSelection.rowIds[0]);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddressSearchPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openFeedbackPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setOpenFeedbackPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblFeedback')}</DialogTitle>
        <DialogContent className={classes.backdrop}>
          <Grid container spacing={1}>
            {!feedbackDataList ? (
              <div />
            ) : (
              feedbackDataList.map((item, index) => (
                <Grid item xs={12} sm={3} lg={3} key={index}>
                  <Card className={classes.cardsMaxF}>
                    <CardActionArea onClick={() => {
                      GetWorkCaseFeedback(item)
                      GetFeedbackDesc(item)
                    }} >
                      <CardContent className={classes.cardsContentMaxF}>
                        <Typography gutterBottom variant="h6" component="h1">
                          {item.WorkCaseId} -{' '}
                          <Chip
                            style={{
                              color: (item.StatusId === 1 ? 'orange' : (item.StatusId === 2 ? 'black' : (item.StatusId === 3 ? 'green' : (item.StatusId === 4 ? 'red' : 'purple'))))
                            }}
                            icon={<SettingsBackupRestoreIcon />}
                            label={item.Status}
                          />
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="p"
                        >
                          <br />
                          {t('lblOpenDate') + ': ' +
                            moment(item.OpenDate).format('DD.MM.YYYY  HH:mm')}
                          <br />
                          {t('lblCreateUser') + ': ' + item.CreateUser}
                          <br />
                          {item.FeedbackDescription
                            ? t('lblFeedbackDesc') + ': ' +
                            item.FeedbackDescription
                            : t('lblFeedbackDesc') + ': '}
                          <br />
                          {t('lblIssueType') + ': ' + item.IssueName}
                          <br />
                          {item.UpdateUser ? t('lblUpdateUser') + ': ' + item.UpdateUser : t('lblUpdateUser') + ': '}
                          <br />
                          {item.UpdateDate ? t('lblUpdateDate') + ': ' + moment(item.UpdateDate).format('DD.MM.YYYY  HH:mm') : t('lblUpdateDate') + ': '}
                          <br />
                          {t('lblNote') + ': ' + item.Comment}
                          < br />
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      <Button
                        size="small"
                        onClick={() => {
                          GetWorkCaseFeedback(item)
                          GetFeedbackDesc(item)
                        }}
                      >
                        {t('lblDetail')}
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFeedbackPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openFeedbackDetailPopUp}
        fullWidth={true}
        maxWidth={'sm'}
        onClose={() => setOpenFeedbackDetailPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }} >{t('Feedback History')} </DialogTitle>
        <DialogContent className={classes.backdrop}>
          <Grid item xs={12} sm={12} lg={12}>
            {/* <SearchBar
                inputSizeSmall
                value={searched}
                onChange={searchVal => requestSearch(searchVal)}
                onCancelSearch={() => cancelSearch()}
                style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
              /> */}
          </Grid>
          <CardHeader title={`${t('lblWorkCaseID')}: ${feedback[0]?.WorkCaseId || feedbackList[0]?.WorkCaseId}`} />
          <Divider />
          <Card>
            <List className={classes.root}>
              {feedback?.map((row, index) => (
                <>
                  <ListItem key={row.index} alignItems="flex-start">
                    <ListItemText
                      primary={row.Owner}
                      secondary={
                        <React.Fragment>
                          <Typography
                            component="span"
                            variant="body2"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {row.Status + ' — ' + row.Reply}
                          </Typography>
                          {' — ' + row.CreateDate}
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                  <Divider variant="middle" component="li" />
                </>
              ))}
            </List>
            <CardContent>
              <Typography gutterBottom variant="h6" component="h1">
                {feedbackList[0]?.Owner}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                component="p"
              >
                {feedbackList[0]?.FeedbackDescription + ' — ' + feedbackList[0]?.OpenDate}
              </Typography>
            </CardContent>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenFeedbackDetailPopup(false);
            setOpenFeedbackPopup(true);
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      {/* NPS Kaldırıldı Popup */}
      {/* <Dialog
        open={InformationPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setInformationPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"
          style={{
            textAlign: 'left'
          }}
        >{t('lblNPS')}</DialogTitle>
        <DialogContent className={classes.backdrop}>
          <Grid container spacing={1}
            direction="row"
            justifyContent="center"
            alignItems="center">
            {!InformationData ? (
              <Grid item xs={12} >
                <Typography gutterBottom variant="h6" component="h1" style={{ textAlign: 'center' }}>
                  {t('lblNoNps')}
                  <IconButton
                    edge="end"
                  >
                    <FreeBreakfastIcon />
                  </IconButton>
                </Typography>
              </Grid>
            ) : (
              InformationData.map((item, index) => (
                <Grid item xs={12} sm={3} lg={3} key={index} >
                  <Card className={classes.cardsMaxF}>
                    <CardActionArea onClick={() => getNpsDetail(item.AnswerHeaderId, item.WorkOrderId, item.ServiceShopId)}>
                    <CardContent className={classes.cardsContentMaxF}>
                        <Typography gutterBottom variant="h6" component="h1">
                          <Chip
                            style={{
                              color: ('red')
                            }}
                            icon={<QuestionAnswerIcon />}
                            label={moment(item.SurveyDate).format('DD.MM.YYYY  HH:mm')}
                          />
                        </Typography>
                        <Typography
                          variant="body2"
                          color="primary"
                          component="p"
                        >
                          <br />
                          {t('lblSurveyDate') + ': ' +
                            moment(item.SurveyDate).format('DD.MM.YYYY')}
                          <br />
                          {t('lblWorkOrderId') + ': ' + item.WorkOrderId}
                          <br />
                          {t('lblServiceShopId') + item.ServiceShopId}
                          <br />
                          {t('lblType') + ': ' + item.Type}
                          <br />
                          {t('lblSurveyDsc') + ': ' + item.SurveyDsc}
                          <br />
                          {item.NpsScore ? t('lblScala') + ': ' + item.NpsScore : t('lblScala') + ': 0'}
                          <br />
                          {item.LowReason ? t('lblLowReason') + ': ' + item.LowReason : ''}
                          <br />
                          <br />
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      {item.AnswerHeaderId === 0 ? '' :
                        <Button
                          size="small"
                          //variant="contained" 
                          style={{
                            marginLeft: 75
                          }}
                          endIcon={<CreateIcon>{t('lblDetail')}</CreateIcon>}
                          onClick={() => {
                            setInformationDetailPopup(true)
                            setWorkOrderId(item.WorkOrderId)
                            setInfoServiceShopId(item.ServiceShopId)
                          }}
                        >
                          {t('lblDetail')}
                        </Button>
                      }
                    </CardActions>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setInformationPopup(false)
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={InformationDetailPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setInformationDetailPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"
          style={{
            textAlign: 'center'
          }}
        >{t('lblNPS')}</DialogTitle>
        <DialogContent className={classes.backdrop}>
          <DialogContent>
            <InformationSurvey ReceiptNo={workOrderId} ServiceShopId={infoServiceShopId} />
          </DialogContent>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setInformationDetailPopup(false);
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog> */}



      {/* ıd=10 olan application type seçildiğinde çıkan popup */}
      <Dialog
        open={insertAssetPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setInsertAssetPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className={classes.backdrop}>
          <AssertInsertDialog WorkOrderId={savedWorkOrderId} closePopup={() => closeInserAssetPopup()} />
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={() => {
            setInsertAssetPopup(false);
          }} color="secondary">
            {t('lblSave')}
          </Button>
          <Button onClick={() => {
            setInsertAssetPopup(false);
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions> */}
      </Dialog>

      <Dialog
        open={insertAssetDaysPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setInsertAssetDaysPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className={classes.backdrop}>
          <AssertInsertDaysDialog WorkOrderId={savedWorkOrderId} closePopup={() => closeInserAssetDaysPopup()} />
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={() => {
            setInsertAssetPopup(false);
          }} color="secondary">
            {t('lblSave')}
          </Button>
          <Button onClick={() => {
            setInsertAssetPopup(false);
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions> */}
      </Dialog>

      {/*MATERIAL ORDERS*/}
      <Dialog
        open={openMaterialOrdersPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setOpenMaterialOrdersPopUp(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: 'auto' }}>{t('lblMaterialOrders')}</span>
          <Button
            style={{ borderRadius: '50%', backgroundColor: '#A9B388', width: '40px', height: '40px', minWidth: 'unset', marginLeft: '500px' }}
            onClick={() => {
              setOpenMaterialOrder(true)
            }}
          >
            <AddIcon style={{ fontSize: '24px', color: 'white' }} />
          </Button>
        </DialogTitle>
        <DialogContent className={classes.backdrop}>
          <Grid container spacing={1}>
            {!consumerMaterialOrders ? (
              <div />
            ) : (
              consumerMaterialOrders.map((item, index) => (
                <Grid item xs={12} sm={3} lg={3} key={index}>
                  <Card
                    className={classes.cardsMaxM}
                    onMouseEnter={() => setFabVisible(index)}
                    onMouseLeave={() => setFabVisible(null)}
                    onClick={() => GetMaterialOrderFromOrderId(item)}
                  >
                    <CardContent className={classes.cardsContentMax}>
                      <Typography gutterBottom variant="h6" component="h1">
                        {item.OrderId} -{' '}
                        <Chip
                          style={{
                            color: (item.StatusId === 1 ? 'green' : (item.StatusId === 2 ? 'red' : (item.StatusId === 3 ? 'purple' : 'gray')))
                          }}
                          icon={item.StatusId === 1 ? <ShoppingCartIcon style={{ color: 'green' }} /> : item.StatusId === 2 ? <CancelIcon style={{ color: 'red' }} /> : item.StatusId === 3 ? <SendIcon style={{ color: 'purple' }} /> : ''}
                          label={item.MaterialOrderStatus}
                        />
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        <br />
                        {t('lblOrderDate') + ': ' +
                          moment(item.OrderDate).format('DD.MM.YYYY')}
                        <br />
                        {t('lblWorkOrderId') + ': ' + item.WorkOrderId}
                        <br />
                        {t('lblSapNo') + ': ' + item.SapNo}
                        <br />
                        {t('lblServiceShop') + ': ' + item.ServiceShop}
                        < br />
                        {t('lblShipTo') + ': ' + item.ShipTo}
                        < br />
                        {t('lblDsc') + ': ' + item.Dsc}
                        < br />
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Fab
                        color="secondary"
                        size="small"
                        className={`${classes.fab} ${fabVisible === index ? classes.fabVisible : ''}`}
                        onClick={() => {
                          GetMaterialOrderFromOrderId(item)
                        }}
                      >
                        <ArrowRightAltIcon style={{ fontSize: '24px', verticalAlign: 'middle' }} />
                      </Fab>
                    </CardActions>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenMaterialOrdersPopUp(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
    </>

  );
}

AssignedJob.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({ tasks: state.tasks1 }), {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials,
  setTask
})(AssignedJob);
